/* eslint-disable camelcase */
import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';

import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { Helper } from '../../../common/helpers/Helper';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { AppConfig } from '../../../AppConfig';
import { UiHelper } from '../../../common/helpers/UiHelper';
import TableCard from '../../../common/components/tables/TableCard';
import { Collapse, Dialog, FormControl, Grid, IconButton, TableCell, TableRow, TextField, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import { StatCard } from '../../../common/components/StatCard';
import { CommonTheme } from '../../../styles/Styles';
import { ReactDateRangeWrapper } from '../../../common/components/DateRangeComponent/ReactDateRangeWrapper';
import moment from 'moment-timezone'
import { CampaignReportsHelper } from '../../../common/helpers/CampaignReportsHelper';
import { DateRanges } from '../../../common/components/DateRangeComponent/DateRanges';
import { AppHelper } from '../../../helpers/AppHelper';
import { Controller } from '../../../common/Controller';

function prioritizeReportByActive(report, adPlatform) {
  let activeStatus = ['ACTIVE']

  if (adPlatform === 'google') {
    activeStatus = ['ELIGIBLE','LIMITED']
  } else if (adPlatform === 'linkedin') {
    activeStatus = ['RUNNABLE']
  }

  return report.sort((a, b) => {
    const aIndex = activeStatus.indexOf(a.status)
    const bIndex = activeStatus.indexOf(b.status)

    if (aIndex !== -1 && bIndex === -1) return -1
    if (aIndex === -1 && bIndex !== -1) return 1
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex

    return 0
  })
}

function getConversionResultLabelFromIndicator(indicator) {
  function normalizeActionType(str) {
    const prefix = 'offsite_conversion.fb_pixel_custom.'

    if (str && str.startsWith(prefix)) {
      return str.slice(prefix.length)
    }

    return str
  }

  const actionType = indicator.substring(indicator.indexOf(':') + 1)

  const actionMapping = {
    reach: 'Reach',
    'app_custom_event.fb_mobile_achievement_unlocked': 'Mobile App Feature Unlocks',
    'app_custom_event.fb_mobile_activate_app': 'Mobile App Starts',
    'app_custom_event.fb_mobile_add_payment_info': 'Mobile App Payment Details',
    'app_custom_event.fb_mobile_add_to_cart': 'Mobile App Adds To Cart',
    'app_custom_event.fb_mobile_add_to_wishlist': 'Mobile App Adds to Wishlist',
    'app_custom_event.fb_mobile_complete_registration': 'Mobile App Registrations',
    'app_custom_event.fb_mobile_content_view': 'Mobile App Content Views',
    'app_custom_event.fb_mobile_initiated_checkout': 'Mobile App Checkouts',
    'app_custom_event.fb_mobile_level_achieved': 'Mobile App Achievements',
    'app_custom_event.fb_mobile_purchase': 'Mobile App Purchases',
    'app_custom_event.fb_mobile_rate': 'Mobile App Ratings',
    'app_custom_event.fb_mobile_search': 'Mobile App Searchs',
    'app_custom_event.fb_mobile_spent_credits': 'Mobile App Credit Spends',
    'app_custom_event.fb_mobile_tutorial_completion': 'Mobile App Tutorial Completions',
    'app_custom_event.other': 'Other Mobile App Actions',
    app_install: 'App Installs',
    app_use: 'App Uses',
    checkin: 'Check-ins',
    comment: 'Post Comments',
    credit_spent: 'Credit Spends',
    'games.plays': 'Game Plays',
    landing_page_view: 'Landing Page Views',
    like: 'Page Likes',
    link_click: 'Link Clicks',
    mobile_app_install: 'Mobile App Installs',
    'offsite_conversion.custom.<custom_conv_id>': 'Custom Conversions defined by the advertiser',
    'offsite_conversion.fb_pixel_add_payment_info': 'Adds Payment Info',
    'offsite_conversion.fb_pixel_add_to_cart': 'Adds To Cart',
    'offsite_conversion.fb_pixel_add_to_wishlist': 'Adds To Wishlist',
    'offsite_conversion.fb_pixel_complete_registration': 'Completed Registration',
    'offsite_conversion.fb_pixel_custom': 'Custom pixel events defined by the advertiser',
    'offsite_conversion.fb_pixel_initiate_checkout': 'Initiates Checkout',
    'offsite_conversion.fb_pixel_lead': 'Leads',
    'offsite_conversion.fb_pixel_purchase': 'Purchases',
    'offsite_conversion.fb_pixel_search': 'Searchs',
    'offsite_conversion.fb_pixel_view_content': 'Views Content',
    'onsite_conversion.flow_complete': 'On-Facebook Workflow Completions',
    'onsite_conversion.messaging_block': 'Blocked Messaging Conversations',
    'onsite_conversion.messaging_conversation_started_7d': 'Messages',
    'onsite_conversion.messaging_first_reply': 'New Messaging Conversations',
    'onsite_conversion.messaging_user_subscribed': 'Messaging Subscriptions',
    'onsite_conversion.post_save': 'Post Saves',
    'onsite_conversion.purchase': 'On-Facebook Purchases',
    outbound_click: 'Outbound Clicks',
    photo_view: 'Page Photo Views',
    post: 'Post Shares',
    post_reaction: 'Post Reactions',
    rsvp: 'Event Responses',
    video_view: '3-Second Video Views',
    contact_total: 'Contacts',
    contact_website: 'Website Contacts',
    contact_mobile_app: 'Mobile App Contacts',
    contact_offline: 'Offline Contacts',
    customize_product_total: 'Products Customized',
    customize_product_website: 'Website Customise Products',
    customize_product_mobile_app: 'Mobile App Products Customized',
    customize_product_offline: 'Offline Products Customized',
    donate_total: 'Donations',
    donate_website: 'Website Donations',
    donate_on_facebook: 'On Facebook Donations',
    donate_mobile_app: 'Mobile App Donations',
    donate_offline: 'Offline Donations',
    find_location_total: 'Location Searches',
    find_location_website: 'Website Location Searches',
    find_location_mobile_app: 'Mobile App Location Searches',
    find_location_offline: 'Offline App Location Searches',
    schedule_total: 'Appointments Scheduled',
    schedule_website: 'Website Appointments Scheduled',
    schedule_mobile_app: 'Mobile App Appointments Scheduled',
    schedule_offline: 'Offline App Appointments Scheduled',
    start_trial_total: 'Trials Started',
    start_trial_website: 'Website Trials Started',
    start_trial_mobile_app: 'Mobile App Trials Started',
    start_trial_offline: 'Offline Trials Started',
    submit_application_total: 'Applications Submitted',
    submit_application_website: 'Website Applications Submitted',
    submit_application_mobile_app: 'Mobile App Applications Submitted',
    submit_application_offline: 'Offline Applications Submitted',
    submit_application_on_facebook: 'On Facebook Applications Submitted',
    subscribe_total: 'Subscriptions',
    subscribe_website: 'Website Subscriptions',
    subscribe_mobile_app: 'Mobile App Subscriptions',
    subscribe_offline: 'Offline Subscriptions',
    recurring_subscription_payment_total: 'Recurring Subscription Payments',
    recurring_subscription_payment_website: 'Website Recurring Subscription Payments',
    recurring_subscription_payment_mobile_app: 'Mobile App Recurring Subscription Payments',
    recurring_subscription_payment_offline: 'Offline Recurring Subscription Payments',
    cancel_subscription_total: 'Canceled Subscriptions',
    cancel_subscription_website: 'Website Canceled Subscriptions',
    cancel_subscription_mobile_app: 'Mobile App Canceled Subscriptions',
    cancel_subscription_offline: 'Offline Canceled Subscriptions',
    ad_click_mobile_app: 'In-App Ad Clicks',
    ad_impression_mobile_app: 'In-App Ad Impressions',
    click_to_call_call_confirm: 'Estimated Call Confirmation Clicks',
    click_to_call_native_call_placed: 'Calls Placed',
    click_to_call_native_20s_call_connect: '20s Calls Placed',
    click_to_call_native_60s_call_connect: '60s Calls Placed',
    page_engagement: 'Page Engagement',
    post_engagement: 'Post Engagement',
    'onsite_conversion.lead_grouped': 'Meta Leads',
    lead: 'All offsite leads plus all On-Facebook leads',
    leadgen_grouped: 'On-Facebook leads (Messenger & Instant Forms)',
    omni_app_install: 'App Installs',
    omni_purchase: 'Purchases',
    omni_add_to_cart: 'Adds to Cart',
    omni_complete_registration: 'Registrations Completed',
    omni_view_content: 'Content Views',
    omni_search: 'Searches',
    omni_initiated_checkout: 'Checkouts Initiated',
    omni_achievement_unlocked: 'Achievements Unlocked',
    omni_activate_app: 'App Activations',
    omni_level_achieved: 'Levels Achieved',
    omni_rate: 'Ratings Submitted',
    omni_spend_credits: 'Credit Spends',
    omni_tutorial_completion: 'Tutorials Completed',
    omni_custom: 'Custom Events'
  }

  let resultLabel = 'Unknown'
  if(actionType) {
    if(actionMapping[actionType]) {
      resultLabel = actionMapping[actionType]
    } else if(actionType === 'mixed') {
      resultLabel = 'Multiple conversions'
    } else {
      resultLabel = normalizeActionType(actionType)
    }
  }

  return resultLabel
}

function getConversionsData(campaign) {
  let conversionsData = {type: 'Unknown', value: 'Unknown'}
  if(campaign && campaign.results && campaign.results.length > 0 && campaign.results[0].indicator) {
    let count  = 0
    const results = campaign.results[0]
    if(results && results.values && results.values.length > 0) {
      count = results.values[0].value || 0
    }
    conversionsData = {type: getConversionResultLabelFromIndicator(campaign.results[0].indicator), value: count}
  } else if(campaign && campaign.objective === 'OUTCOME_LEADS') {
    const leadsActionType = 'onsite_conversion.lead_grouped'
    const leadsAction = Array.isArray(campaign.actions) && campaign.actions.find(action => action.action_type === leadsActionType)
    conversionsData = {type: getConversionResultLabelFromIndicator(leadsActionType), value: leadsAction ? (leadsAction.value || 0) : 0}
  }
  return conversionsData
}

function getAggregatedStats(data,adPlatform) {
  let statsInitialValue = null
  if(adPlatform === 'meta') {
    statsInitialValue = { impressions: 0, spend: 0, reach: 0, clicks:0, ctr: 0, conversationsStarted: 0, metaLeads: 0, websiteLeads: 0, callsPlaced: 0, linkClicks: 0, postEngagements: 0 }
  } else if(adPlatform === 'google' || adPlatform === 'linkedin') {
    statsInitialValue = { impressions: 0, spend: 0, clicks:0, ctr: 0, conversions: 0}
  }
  if(!data || data.length === 0) {
    return statsInitialValue
  }

  let stats = null
  if(adPlatform === 'meta') {
    stats = data.reduce((acc, item) => {
      if(item) {
        let conversationsStarted = null
        let metaLeads = null
        let websiteLeads = null
        let callsPlaced = null
        let linkClicks = null
        let postEngagements = null

        if(item.actions && item.actions.length > 0) {
          conversationsStarted =  item.actions.find(action => action.action_type === 'onsite_conversion.messaging_conversation_started_7d')
          metaLeads =  item.actions.find(action => action.action_type === 'onsite_conversion.lead_grouped')
          websiteLeads =  item.actions.find(action => action.action_type === 'onsite_web_lead')
          callsPlaced =  item.actions.find(action => action.action_type === 'click_to_call_native_call_placed')
          linkClicks =  item.actions.find(action => action.action_type === 'link_click')
          postEngagements = item.actions.find(action => action.action_type === 'post_engagement')
        }

        acc.impressions += (Number(item.impressions) || 0)
        acc.spend += (Number(item.spend) || 0)
        acc.reach += (Number(item.reach) || 0)
        acc.clicks += (Number(item.clicks) || 0)
        acc.conversationsStarted += (conversationsStarted && conversationsStarted.value) ? Number(conversationsStarted.value) : 0
        acc.metaLeads += (metaLeads && metaLeads.value) ? Number(metaLeads.value) : 0
        acc.websiteLeads += (websiteLeads && websiteLeads.value) ? Number(websiteLeads.value) : 0
        acc.callsPlaced += (callsPlaced && callsPlaced.value) ? Number(callsPlaced.value) : 0
        acc.linkClicks += (linkClicks && linkClicks.value) ? Number(linkClicks.value) : 0
        acc.postEngagements += (postEngagements && postEngagements.value) ? Number(postEngagements.value) : 0
      }
      return acc
    }, statsInitialValue)
  } else if(adPlatform === 'google') {
    stats = data.reduce((acc, item) => {
      if(item) {
        acc.impressions += (Number(item.impressions) || 0)
        acc.spend += (Number(item.spend) || 0)
        acc.reach += (Number(item.reach) || 0)
        acc.clicks += (Number(item.clicks) || 0)
        acc.conversions += (Number(item.conversions) || 0)
      }
      return acc
    }, statsInitialValue)
  } else if(adPlatform === 'linkedin') {
    stats = data.reduce((acc, item) => {
      if(item) {
        acc.impressions += (Number(item.impressions) || 0)
        acc.spend += (Number(item.spend) || 0)
        acc.clicks += (Number(item.clicks) || 0)
        acc.conversions += (Number(item.conversions) || 0)
      }
      return acc
    }, statsInitialValue)
  }

  let ctr = 0
  if(stats) {
    if(stats.clicks > 0 && stats.impressions  > 0) {
      ctr = (stats.clicks / stats.impressions) * 100
    }
    stats.ctr = ctr
  }
  return stats
}

function getCampaignReportData(adPlatform,insightsReport, dataReport) {
  let customReport = []

  if(adPlatform === 'meta') {
    customReport = insightsReport.map(item => {
      const statusObj = dataReport.find(statusObj => statusObj.id === item.campaign_id)
      const conversions = getConversionsData(item)
      let costPerConversion = 0
      if(conversions && conversions.type !== 'Unknown' && conversions.value !== 'Unknown' && conversions.value > 0) {
        costPerConversion = Math.round((item.spend / conversions.value) * 100) / 100
      }

      return {
        campaignId: item.campaign_id,
        campaignName: item.campaign_name,
        status: (statusObj && statusObj.effective_status) ?  statusObj.effective_status.replace(/_/g, ' ') : 'UNKNOWN',
        objective: item.objective ? item.objective.replace(/^OUTCOME_/, '').replace(/_/g, ' ').toLowerCase().replace(/^./, c => c.toUpperCase()) : '',
        dateCreated: item.created_time || (statusObj && statusObj.created_time) || '',
        frequency: item.frequency ? Number(item.frequency).toFixed(2) : 0,
        spend: (Math.round(item.spend * 100) / 100) || 0,
        impressions: item.impressions || 0,
        reach: item.reach || 0,
        ctr: item.ctr ? `${Number(item.ctr).toFixed(2)}%` : '0%',
        conversions: {value: conversions.value, additionalInfo: conversions.type},
        costPerConversion
      }
    })
    customReport = customReport.sort((a, b) => b.impressions - a.impressions).filter((report)=> report.status === 'ACTIVE' || (report.status !== 'ACTIVE' && report.spend > 0))
  } else if(adPlatform === 'google') {
    customReport = insightsReport.map(item => {
      const spend = (item && item.metrics && item.metrics.costMicros) ? (Number(item.metrics.costMicros) / 1000000).toFixed(2) : 0
      const conversions = (item && item.metrics && item.metrics.conversions) ? item.metrics.conversions : 0
      return {
        campaignId: item && item.campaign && item.campaign.id,
        campaignName: item && item.campaign && item.campaign.name,
        status: (item && item.campaign && item.campaign.primaryStatus) ? item.campaign.primaryStatus.replace(/_/g, ' ') : '',
        campaignType: (item && item.campaign && item.campaign.advertisingChannelType) ? item.campaign.advertisingChannelType.replace(/_/g, ' ').toLowerCase().replace(/^./, c => c.toUpperCase()) : '',
        spend: spend,
        impressions: (item && item.metrics && item.metrics.impressions) ? item.metrics.impressions : 0,
        clicks: (item && item.metrics && item.metrics.clicks) ? item.metrics.clicks : 0,
        ctr: (item && item.metrics && item.metrics.clicks && item.metrics.impressions && Number(item.metrics.impressions) > 0) ? `${((Number(item.metrics.clicks) / Number(item.metrics.impressions)) * 100).toFixed(2)}%` : '0%',
        conversions: conversions,
        costPerConversion: (conversions > 0) ? (spend / conversions).toFixed(2) : 0
      }
    })
    customReport = customReport.filter((report)=> ['ELIGIBLE','LIMITED'].includes(report.status) || (!['ELIGIBLE','LIMITED'].includes(report.status) && report.spend > 0))
  } else if(adPlatform === 'linkedin') {
    customReport = insightsReport.map(item => {
      const campaignId = item && Array.isArray(item.pivotValues) && item.pivotValues[0] && item.pivotValues[0].replace('urn:li:sponsoredCampaign:', '')
      const spend = (item && item.costInLocalCurrency) ? (Number(item.costInLocalCurrency)).toFixed(2) : 0
      const conversions = CampaignReportsHelper.getLinkedInConversions(item)
      if(campaignId) {
        const campaignDetails = dataReport.find(dataObj => Number(dataObj.id) === Number(campaignId))
        return {
          campaignId: campaignId,
          campaignName: campaignDetails.name || '',
          status: (campaignDetails && campaignDetails.servingStatuses && campaignDetails.servingStatuses.length > 0) ?  campaignDetails.servingStatuses[0].replace(/_/g, ' ') : 'UNKNOWN',
          objective: campaignDetails.objectiveType ? campaignDetails.objectiveType.replace(/_/g, ' ').toLowerCase().replace(/^./, c => c.toUpperCase()) : '',
          spend: spend,
          impressions: item.impressions || 0,
          clicks: (item && item.clicks) ? item.clicks : 0,
          ctr: (item && item.clicks && item.impressions && Number(item.impressions) > 0) ? `${((Number(item.clicks) / Number(item.impressions)) * 100).toFixed(2)}%` : '0%',
          conversions: conversions,
          costPerConversion: (conversions > 0) ? (spend / conversions).toFixed(2) : 0,
          campaignGroupId: campaignDetails.campaignGroup
            ? String(campaignDetails.campaignGroup).replace('urn:li:sponsoredCampaignGroup:', '')
            : ''
        }
      }
    }).filter(a => !!a)
  }
  customReport = prioritizeReportByActive(customReport,adPlatform)
  return customReport
}

function generateCampaignsReport(data,adPlatform) {
  if(!data || data.length === 0) {
    return {}
  }

  let reportHeaders = []
  let activeStatusValues = []
  let activeStatusSecondaryValues = []
  const hiddenColumns = [0]
  let additionalInfoColumns = []
  const statusColumn = 2
  let reportHeaderTooltips = []

  if(adPlatform === 'meta') {
    reportHeaders = ['Campaign ID','Campaign Name', 'Status', 'Objective', 'Created Date', 'Frequency', 'Spent', 'Impressions', 'Reach', 'CTR', 'Conversions', 'CPC']
    reportHeaderTooltips = ['Campaign ID','Campaign Name', 'Status', 'Objective', 'Created Date', 'Frequency', 'Spent', 'Impressions', 'Reach', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions']
    additionalInfoColumns = [10]
    activeStatusValues = ['ACTIVE']
  } else if(adPlatform === 'google') {
    reportHeaders = ['Campaign ID','Campaign Name', 'Status', 'Campaign Type', 'Spent', 'Impressions', 'Clicks', 'CTR', 'Conversions', 'CPC']
    reportHeaderTooltips = ['Campaign ID','Campaign Name', 'Status', 'Campaign Type', 'Spent', 'Impressions', 'Clicks', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions']
    activeStatusValues = ['ELIGIBLE']
    activeStatusSecondaryValues = ['LIMITED']
  } else if(adPlatform === 'linkedin') {
    reportHeaders = ['Campaign ID','Campaign Name', 'Status', 'Objective', 'Spent', 'Impressions', 'Clicks', 'CTR', 'Conversions', 'CPC']
    reportHeaderTooltips = ['Campaign ID','Campaign Name', 'Status', 'Objective', 'Spent', 'Impressions', 'Clicks', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions']
    activeStatusValues = ['RUNNABLE']
  }

  return {
    headers: reportHeaders,
    headerTooltips: reportHeaderTooltips,
    rows: data.map(({campaignGroupId, ...item}) => Object.values(item)),
    textColumnIndices: [1],
    columnsWithAdditionalInfo: additionalInfoColumns,
    hiddenColumnIndices: hiddenColumns,
    renderCustomTableBody: (cellValue, columnIndex) => {
      if(columnIndex === statusColumn) {
        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody)}>
            <span className={activeStatusValues.includes(cellValue) ? css(Styles.statusBadge, Styles.statusBadgeActive) : activeStatusSecondaryValues.includes(cellValue) ? css(Styles.statusBadge, Styles.statusBadgeActiveSecondary) : css(Styles.statusBadge)}>{cellValue}</span>
          </TableCell>
        )
      }
      return null
    }
  }
}

function constructAudienceLocationsData(places) {
  let data = []

  const countryNames = {
    NG: 'Nigeria',
    US: 'United States'
  }

  if(places) {
    const transformedPlaces = places.map(function (place) {
      const name = (place && place.name) ? place.name : ''
      const radius = typeof place.radius === 'number' ? place.radius : 0
      return {
        ...place,
        display: name + ' (+' + radius + ' km)'
      }
    })

    const groupedByCountry = {}
    transformedPlaces.forEach(function (place) {
      const code = place.country || ''
      if (!groupedByCountry[code]) {
        groupedByCountry[code] = []
      }
      groupedByCountry[code].push(place.display)
    })

    data = Object.keys(groupedByCountry).map(function (code) {
      const label = countryNames[code] || code
      return label + ': ' + groupedByCountry[code].join(', ')
    })
  }

  return data
}

function generateAudienceData(targetingData) {
  const audienceData = {}

  if(targetingData) {
    if(targetingData.age_min || targetingData.age_max) {
      const minAge = targetingData.age_min || ''
      const maxAge = targetingData.age_max ? (targetingData.age_max === 65 ? '65+' : targetingData.age_max) : ''
      audienceData.age = {
        title: 'Age',
        data: `${minAge} - ${maxAge}`
      }
    } else {
      audienceData.age = {
        title: 'Age',
        data: 'All'
      }
    }
    if(Array.isArray(targetingData.genders) && targetingData.genders.length > 0 && [1,2].includes(targetingData.genders[0])) {
      let gender = ''
      if(targetingData.genders[0] === 1) {
        gender = 'Men'
      } else if(targetingData.genders[0] === 2) {
        gender = 'Women'
      }
    } else {
      audienceData.gender = {
        title: 'Gender',
        data: 'All'
      }
    }
    if(targetingData.geo_locations || targetingData.excluded_geo_locations) {
      audienceData.locations = {
        title: 'Locations',
        data: {}
      }
      if(targetingData.geo_locations && targetingData.geo_locations.places && targetingData.geo_locations.places.length > 0) {
        const places = targetingData.geo_locations.places
        const locationsData = constructAudienceLocationsData(places)

        audienceData.locations.data.included = {
          title: 'Included location',
          data: locationsData
        }
      } else if(targetingData.excluded_geo_locations && targetingData.excluded_geo_locations.places && targetingData.excluded_geo_locations.places.length > 0) {
        const places = targetingData.excluded_geo_locations.places
        const locationsData = constructAudienceLocationsData(places)

        audienceData.locations.data.excluded = {
          title: 'Excluded location',
          data: locationsData
        }
      }
    } else {
      audienceData.locations = {
        title: 'Locations',
        data: {
          included: {
            title: 'Included location',
            data: 'All'
          }
        }
      }
    }
    if(Array.isArray(targetingData.flexible_spec) && targetingData.flexible_spec.length > 0 && Array.isArray(targetingData.flexible_spec[0].interests) && targetingData.flexible_spec[0].interests.length > 0) {
      const interests = targetingData.flexible_spec[0].interests.map((interest)=> interest.name).join(', ')
      audienceData.interests = {
        title: 'Interests',
        data: interests
      }
    } else {
      audienceData.interests = {
        title: 'Interests',
        data: 'All'
      }
    }
    if(Array.isArray(targetingData.behaviors) && targetingData.behaviors.length > 0) {
      const behaviors = targetingData.behaviors.map((behavior)=> behavior.name).join(', ')
      audienceData.behaviors = {
        title: 'Behaviours',
        data: behaviors
      }
    } else {
      audienceData.behaviors = {
        title: 'Behaviours',
        data: 'All'
      }
    }
  }

  return audienceData
}

function renderAudienceData(audience) {
  return(<TableRow>
    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
      <Collapse in={true} timeout='auto' unmountOnExit>
        {/* TODO: UI for audience details*/}
      </Collapse>
    </TableCell>
  </TableRow>)
}

function getAdReportData(report,adPlatform,customerData, campaignName) {
  let customReport = []
  if(adPlatform === 'meta') {
    customReport =  report.map(item => {
      let adsInsightsReport = {frequency: 0, spend: 0, impressions: 0, reach: 0, ctr: '0%', conversions: {value: 'Unknown', additionalInfo: 'Unknown'}}
      let adsLinksReport = {facebookPostLink: '', instgramPostLink: ''};
      let costPerConversion = 0
      if(item && item.insights && item.insights.data && item.insights.data.length > 0) {
        const insightsData = item.insights.data[0]
        if(item.campaign && item.campaign.objective) {
          insightsData.objective = item.campaign.objective
        }

        const conversions = getConversionsData(insightsData)
        if(conversions && conversions.type !== 'Unknown' && conversions.value !== 'Unknown' && conversions.value > 0) {
          costPerConversion = Math.round((insightsData.spend / conversions.value) * 100) / 100
        }

        adsInsightsReport = {
          frequency: insightsData.frequency ? Number(insightsData.frequency).toFixed(2) : 0,
          spend: (Math.round(insightsData.spend * 100) / 100) || 0,
          impressions: insightsData.impressions || 0,
          reach: insightsData.reach || 0,
          ctr: insightsData.ctr ? `${Number(insightsData.ctr).toFixed(2)}%` : '0%',
          conversions: {value: conversions.value, additionalInfo: conversions.type},
        }
      }
      if(item && item.creative) {
        const facebookPostLink = item.creative.effective_object_story_id && `https://www.facebook.com/${item.creative.effective_object_story_id}`
        const instgramPostLink = item.creative.instagram_permalink_url
        adsLinksReport = {
          facebookPostLink,
          instgramPostLink
        }
      }

      let audienceData = null
      if(item && item.adset && item.adset.targeting) {
        const targetingData = item.adset.targeting
        audienceData = generateAudienceData(targetingData)
      }

      return ({
        adId: item.id,
        adName: item.name,
        status: item.effective_status ? item.effective_status.replace(/_/g, ' ') : 'UNKNOWN',
        dateCreated: item.created_time ? moment(item.created_time).format('YYYY-MM-DD') : '',
        ...adsInsightsReport,
        costPerConversion,
        ...adsLinksReport,
        campaignName: item && item.campaign && item.campaign.name,
        audience: audienceData
      })
    }
    )
    customReport = customReport.filter((report)=> report.status === 'ACTIVE' || (report.status !== 'ACTIVE' && report.spend > 0))
  } else if(adPlatform === 'google') {
    customReport =  report.map(item => {
      const spend = item.metrics.costMicros ? (Number(item.metrics.costMicros) / 1000000).toFixed(2) : 0
      const conversions = item.metrics.conversions || 0
      let adsInsightsReport = {spend: 0, impressions: 0, ctr: '0%', conversions: 0, costPerConversion: 0}
      if(item && item.metrics) {
        adsInsightsReport = {
          spend: spend,
          impressions: item.metrics.impressions || 0,
          clicks: item.metrics.clicks || 0,
          ctr: (item.metrics.clicks && item.metrics.impressions && Number(item.metrics.impressions) > 0) ? `${((Number(item.metrics.clicks) / Number(item.metrics.impressions)) * 100).toFixed(2)}%` : '0%',
          conversions: conversions,
          costPerConversion: (conversions > 0) ? (spend / conversions).toFixed(2) : 0
        }
      }

      const campaignId = item && item.campaign && item.campaign.id
      const adGroupId = item && item.adGroup && item.adGroup.id
      const adId = item && item.adGroupAd && item.adGroupAd.ad && item.adGroupAd.ad.id
      let previewLink = null
      if(customerData && customerData.metrics && customerData.metrics.optimizationScoreUrl) {
        const parsedUrl = new URL(customerData.metrics.optimizationScoreUrl)
        const ocid = parsedUrl.searchParams.get('ocid')
        if(ocid) {
          previewLink = `https://ads.google.com/aw/ads/edit/search?campaignId=${campaignId}&ocid=${ocid}&adId=${adId}&adGroupIdForAd=${adGroupId}`
        }
      }

      const finalUrls = (item && item.adGroupAd && item.adGroupAd.ad && item.adGroupAd.ad.finalUrls) ? item.adGroupAd.ad.finalUrls : []
      let headlineValues = [], descriptionValues = []
      if(item && item.adGroupAd && item.adGroupAd.ad && item.adGroupAd.ad.type) {
        if(item.adGroupAd.ad.type === 'RESPONSIVE_SEARCH_AD') {
          const headlines = (item && item.adGroupAd && item.adGroupAd.ad && item.adGroupAd.ad.responsiveSearchAd && item.adGroupAd.ad.responsiveSearchAd.headlines) ? item.adGroupAd.ad.responsiveSearchAd.headlines : []
          headlineValues = headlines.map(headline => headline.text)
          const descriptions = (item && item.adGroupAd && item.adGroupAd.ad && item.adGroupAd.ad.responsiveSearchAd && item.adGroupAd.ad.responsiveSearchAd.descriptions) ? item.adGroupAd.ad.responsiveSearchAd.descriptions : []
          descriptionValues = descriptions.map(headline => headline.text)
        }
      }

      const adSummary = {headlines: headlineValues, finalUrls, descriptions: descriptionValues}
      return ({
        adId: adId,
        ad: adSummary,
        adType: (item && item.adGroupAd && item.adGroupAd.ad && item.adGroupAd.ad.type) ? item.adGroupAd.ad.type.replace(/_/g, ' ').toLowerCase().replace(/^./, c => c.toUpperCase()) : '',
        adGroupName: (item && item.adGroup && item.adGroup.name) ? item.adGroup.name : '',
        status: (item && item.adGroupAd && item.adGroupAd.primaryStatus) ? item.adGroupAd.primaryStatus.replace(/_/g, ' ') : '',
        ...adsInsightsReport,
        previewLink: previewLink,
        campaignName: item && item.campaign && item.campaign.name
      })
    }
    )
    customReport = customReport.filter((report)=> ['ELIGIBLE','LIMITED'].includes(report.status) || (!['ELIGIBLE','LIMITED'].includes(report.status) && report.spend > 0))
  } else if(adPlatform === 'linkedin') {
    customReport =  report.map(item => {
      const spend = item.costInLocalCurrency ? (Number(item.costInLocalCurrency)).toFixed(2) : 0
      const conversions = CampaignReportsHelper.getLinkedInConversions(item)
      const adsInsightsReport = {
        spend: spend,
        impressions: item.impressions || 0,
        clicks: item.clicks || 0,
        ctr: (item.clicks && item.impressions && Number(item.impressions) > 0) ? `${((Number(item.clicks) / Number(item.impressions)) * 100).toFixed(2)}%` : '0%',
        conversions: conversions,
        costPerConversion: (conversions > 0) ? (spend / conversions).toFixed(2) : 0
      }

      const adId = (item && item.id) ? item.id.replace('urn:li:sponsoredCreative:', '') : ''
      let previewLink = null

      if(item.id && item.content && item.content.reference) {
        previewLink = `https://www.linkedin.com/feed/update/urn:li:sponsoredContentV2:(${item.content.reference},${item.id})`
      }

      return ({
        adId: adId,
        adName: (item && item.name) ? item.name : '',
        status: (item && item.isServing) ? 'RUNNABLE' : (item.servingHoldReasons &&  item.servingHoldReasons.length > 0) ? item.servingHoldReasons[0].replace(/_/g, ' ') : 'UNKNOWN',
        ...adsInsightsReport,
        previewLink: previewLink,
        campaignName: (item && item.campaign && item.campaign.name) ? item.campaign.name : campaignName
      })
    }
    )
  }
  customReport = prioritizeReportByActive(customReport,adPlatform)
  return customReport
}

function generateAdsReport(data,adPlatform) {
  if(!data || data.length === 0) {
    return {}
  }

  let reportHeaders = []
  let activeStatusValues = []
  let activeStatusSecondaryValues = []
  let hiddenColumns = []
  let additionalInfoColumns = []
  let statusColumn = 2
  let reportHeaderTooltips = []

  if(adPlatform === 'meta') {
    reportHeaders = ['Ad ID','Ad Name', 'Status', 'Created Date', 'Frequency', 'Spent', 'Impressions', 'Reach', 'CTR', 'Conversions', 'CPC','Facebook','Instagram', 'Campaign Name', 'Audience']
    reportHeaderTooltips = ['Ad ID','Ad Name', 'Status', 'Created Date', 'Frequency', 'Spent', 'Impressions', 'Reach', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions','Facebook','Instagram', 'Campaign Name', 'Audience']
    activeStatusValues = ['ACTIVE']
    additionalInfoColumns = [9]
    hiddenColumns = [0,11,12,13,14]
  } else if(adPlatform === 'google') {
    reportHeaders = ['Ad ID', 'Ad', 'Ad Type', 'Ad Group Name', 'Status', 'Spent', 'Impressions', 'Clicks', 'CTR', 'Conversions', 'CPC', 'Preview Link', 'Campaign Name']
    reportHeaderTooltips = ['Ad ID', 'Ad', 'Ad Type', 'Ad Group Name', 'Status', 'Spent', 'Impressions', 'Clicks', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions', 'Preview Link', 'Campaign Name']
    activeStatusValues = ['ELIGIBLE']
    activeStatusSecondaryValues = ['LIMITED']
    hiddenColumns = [0,11, 12]
    statusColumn = 4
  } else if(adPlatform === 'linkedin') {
    reportHeaders = ['Ad ID', 'Ad Name', 'Status', 'Spent', 'Impressions', 'Clicks', 'CTR', 'Conversions', 'CPC', 'Preview Link', 'Campaign Name']
    reportHeaderTooltips = ['Ad ID', 'Ad Name', 'Status', 'Spent', 'Impressions', 'Clicks', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions', 'Preview Link', 'Campaign Name']
    activeStatusValues = ['RUNNABLE']
    hiddenColumns = [0,9, 10]
  }

  return {
    headers: reportHeaders,
    headerTooltips: reportHeaderTooltips,
    rows: data.map(item => Object.values(item)),
    textColumnIndices: [1],
    columnsWithAdditionalInfo: additionalInfoColumns,
    hiddenColumnIndices: hiddenColumns,
    renderCustomTableBody: (cellValue, columnIndex) => {
      if(adPlatform === 'google' && columnIndex === 1) {
        let headlines, descriptions, finalUrl
        if(cellValue && cellValue.headlines && cellValue.headlines.length > 0) {
          headlines = cellValue.headlines.join(' | ')
        }
        if(cellValue && cellValue.descriptions && cellValue.descriptions.length > 0) {
          descriptions = cellValue.descriptions
        }
        if(cellValue && cellValue.finalUrls && cellValue.finalUrls.length > 0) {
          finalUrl = cellValue.finalUrls[0]
        }

        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody,Styles.adSummaryContainer)}>
            {headlines && <span className={css(Styles.headline)}>{headlines}</span>}
            {finalUrl && <a href={finalUrl} target='_blank' rel='noopener noreferrer' className={css(Styles.finalUrl)}>{finalUrl}</a>}
            {descriptions && <ul className={css(Styles.descriptions)}>{descriptions.map(description => <li>{description}</li>)}</ul>}
          </TableCell>
        )
      } else if(columnIndex === statusColumn) {
        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody)}>
            <span className={activeStatusValues.includes(cellValue) ? css(Styles.statusBadge, Styles.statusBadgeActive) : activeStatusSecondaryValues.includes(cellValue) ? css(Styles.statusBadge, Styles.statusBadgeActiveSecondary) : css(Styles.statusBadge)}>{cellValue}</span>
          </TableCell>
        )
      }
      return null
    },
    renderTableRowCollapse: (rowIndex) => {
      if(data && data[rowIndex]) {
        const audienceData = data[rowIndex].audience
        if(audienceData) {
          return renderAudienceData(audienceData)
        }
      }
      return null
    }
  }
}

function getDateWiseCampaignsReportData(report,adPlatform) {
  let customReport = []
  if(adPlatform === 'meta') {
    customReport =  report.map(item => {
      if(item) {
        let conversationsStarted = null
        let websiteLeads = null
        let metaLeads = null
        let linkClicks = null
        let postEngagements = null

        if(item.actions && item.actions.length > 0) {
          conversationsStarted =  item.actions.find(action => action.action_type === 'onsite_conversion.messaging_conversation_started_7d')
          websiteLeads =  item.actions.find(action => action.action_type === 'onsite_web_lead')
          metaLeads = item.actions.find(action => action.action_type === 'onsite_conversion.lead_grouped')
          linkClicks =  item.actions.find(action => action.action_type === 'link_click')
          postEngagements = item.actions.find(action => action.action_type === 'post_engagement')
        }

        return ({
          date: item.date_start,
          spend: (Math.round(item.spend * 100) / 100) || 0,
          impressions: item.impressions || 0,
          reach: item.reach || 0,
          postEngagements: (postEngagements && postEngagements.value) || 0,
          linkClicks: (linkClicks && linkClicks.value) || 0,
          clicks: item.clicks || 0,
          ctr: item.ctr ? `${Number(item.ctr).toFixed(2)}%` : '0%',
          conversationsStarted: (conversationsStarted && conversationsStarted.value) || 0,
          metaLeads: (metaLeads &&  metaLeads.value) || 0,
          websiteLeads: (websiteLeads &&  websiteLeads.value) || 0,
          accountCurrency: item.account_currency,
          actions: item.actions || []
        })
      }
    }).filter(a => !!a)
    customReport = customReport.sort((a, b) => new Date(b.date) - new Date(a.date))
  } else if(adPlatform === 'google') {
    customReport = report.map(item => {
      const spend = (item && item.metrics && item.metrics.costMicros) ? (Number(item.metrics.costMicros) / 1000000) : 0
      const conversions = (item && item.metrics && item.metrics.conversions) ? Number(item.metrics.conversions) : 0
      return {
        date: item && item.segments && item.segments.date,
        spend: spend,
        impressions: (item && item.metrics && item.metrics.impressions) ? Number(item.metrics.impressions) : 0,
        clicks: (item && item.metrics && item.metrics.clicks) ? Number(item.metrics.clicks) : 0,
        conversions: conversions,
      }
    }).filter(item => !!item.date)

    const aggregatedByDate = customReport.reduce((acc, item) => {
      if(!acc[item.date]) {
        acc[item.date] = {
          date: item.date,
          spend: 0,
          impressions: 0,
          clicks: 0,
          conversions: 0,
        }
      }
      acc[item.date].spend += item.spend
      acc[item.date].impressions += item.impressions
      acc[item.date].clicks += item.clicks
      acc[item.date].conversions += item.conversions
      return acc
    }, {})

    customReport = Object.values(aggregatedByDate).map(item => {
      const spend = Number(item.spend.toFixed(2))
      const conversions = item.conversions
      return {
        date: item.date,
        spend: spend.toFixed(2),
        impressions: item.impressions,
        clicks: item.clicks,
        ctr: (item.clicks > 0 && item.impressions > 0) ? `${((item.clicks / item.impressions) * 100).toFixed(2)}%` : '0%',
        conversions: conversions,
        costPerConversion: (conversions > 0) ? (spend / conversions).toFixed(2) : 0
      }
    }).sort((a, b) => new Date(b.date) - new Date(a.date))
  } else if(adPlatform === 'linkedin') {
    const sortedReport = CampaignReportsHelper.sortLinkedInAnalyticsDescending(report)
    customReport = sortedReport.map(item => {
      const spend = (item && item.costInLocalCurrency) ? (Number(item.costInLocalCurrency)).toFixed(2) : 0
      const conversions = CampaignReportsHelper.getLinkedInConversions(item)
      let date = ''
      if(item && item.dateRange && item.dateRange.start) {
        const year = item.dateRange.start.year
        const month =  item.dateRange.start.month && item.dateRange.start.month - 1
        const day =  item.dateRange.start.day
        if(year && (month || month === 0) && day) {
          date = moment({year, month, date: day}).format('YYYY-MM-DD')
        }
      }
      return {
        date: date,
        spend: spend,
        impressions: (item && item.impressions) ? item.impressions : 0,
        clicks: (item && item.clicks) ? item.clicks : 0,
        ctr: (item && item.clicks && item.impressions && Number(item.impressions) > 0) ? `${((Number(item.clicks) / Number(item.impressions)) * 100).toFixed(2)}%` : '0%',
        conversions: conversions,
        costPerConversion: (conversions > 0) ? (spend / conversions).toFixed(2) : 0
      }
    })
  }
  return customReport
}

function generateDateWiseCampaignsReport(data, adPlatform) {
  if(!data || data.length === 0) {
    return {}
  }

  let reportHeaders = []
  let hiddenColumns = []
  let reportHeaderTooltips = []
  if(adPlatform === 'meta') {
    reportHeaders = ['Date', 'Spent', 'Impressions', 'Reach', 'Post Engagements', 'Link Clicks', 'Clicks', 'CTR', 'Msg Leads', 'Meta Leads', 'Web Leads', 'Currency', 'Actions']
    reportHeaderTooltips = ['Date', 'Spent', 'Impressions', 'Reach', 'Post Engagements', 'Link Clicks', 'Clicks', 'Click-Through Rate', 'Message Leads', 'Meta Leads', 'Web Leads', 'Currency', 'Actions']
    hiddenColumns = [6,11,12]
  } else if(adPlatform === 'google') {
    reportHeaders = ['Date', 'Spent', 'Impressions', 'Clicks', 'CTR', 'Conversions', 'CPC']
    reportHeaderTooltips = ['Date', 'Spent', 'Impressions', 'Clicks', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions']
  } else if(adPlatform === 'linkedin') {
    reportHeaders = ['Date', 'Spent', 'Impressions', 'Clicks', 'CTR', 'Conversions', 'CPC']
    reportHeaderTooltips = ['Date', 'Spent', 'Impressions', 'Clicks', 'Click-Through Rate', 'Conversions', 'Cost Per Conversions']
  }

  return {
    headers: reportHeaders,
    headerTooltips: reportHeaderTooltips,
    rows: data.map(item => Object.values(item)),
    textColumnIndices: [0],
    hiddenColumnIndices: hiddenColumns
  }
}

function getSelectedTimeFrame(timeFrame, adPlatform) {
  const timeFrameMap = {
    meta: {
      today: 'today',
      yesterday: 'yesterday',
      this_week: 'this_week_mon_today',
      this_month: 'this_month',
      last_7d: 'last_7d',
      last_30d: 'last_30d',
    },
    google: {
      today: 'TODAY',
      yesterday: 'YESTERDAY',
      this_week: 'THIS_WEEK_MON_TODAY',
      this_month: 'THIS_MONTH',
      last_7d: 'LAST_7_DAYS',
      last_30d: 'LAST_30_DAYS'
    }
  }

  let selectedTimeFrame = timeFrame

  if(['meta', 'google'].includes(adPlatform)) {
    selectedTimeFrame = timeFrameMap[adPlatform][timeFrame]
  }

  return selectedTimeFrame
}

function getCampaignDataRequestInfo({timeFrame, adPlatform, adAccountId}) {
  const response = {}
  if(adPlatform === 'meta') {
    let additionalQueryItems = {}
    if(['custom', 'last_90d'].includes(timeFrame.id)) {
      additionalQueryItems = {
        time_range: JSON.stringify({since : timeFrame.startValue, until : timeFrame.endValue})
      }
    } else {
      const selectedTimeFrame = getSelectedTimeFrame(timeFrame.id, adPlatform)
      additionalQueryItems = { date_preset: selectedTimeFrame,}
    }
    response.path = ['miscs', 'get-meta-analytics']
    response.jsonBody = {
      requests: [
        {
          path: `act_${adAccountId}/insights`,
          query: {
            level: 'campaign',
            fields: 'ad_id, ad_name, campaign_id, campaign_name, created_time',
            ...additionalQueryItems,
            limit: 100,
            sort:'created_time_descending',
          }
        }
      ]
    }
  } else if(adPlatform === 'google') {
    let customWhereClause = ''
    if(['custom', 'last_90d'].includes(timeFrame.id)) {
      customWhereClause = `WHERE segments.date BETWEEN '${timeFrame.startValue}' AND '${timeFrame.endValue}'`
    } else {
      const selectedTimeFrame = getSelectedTimeFrame(timeFrame.id, adPlatform)
      customWhereClause = `WHERE segments.date DURING ${selectedTimeFrame}`
    }

    response.path = ['miscs', 'get-google-ads-analytics']
    response.jsonBody = {
      requests: [
        {
          path: `${adAccountId}/googleAds:search`,
          body: {
            query: `SELECT campaign.id,campaign.name,campaign.primary_status,metrics.impressions FROM campaign ${customWhereClause} ORDER BY campaign.primary_status ASC,metrics.impressions DESC LIMIT 100`
          }
        }
      ],
    }
  } else if(adPlatform === 'linkedin') {
    const additionalQueryItems = {}
    const dateRangeObj = CampaignReportsHelper.generateLinkedInDateRange(timeFrame)
    response.path = ['miscs', 'get-linkedin-ads-analytics']
    response.jsonBody = {
      requests: [
        {
          path: 'adAnalytics',
          query: {
            q: 'analytics',
            pivot: 'CAMPAIGN',
            timeGranularity: 'ALL',
            ...dateRangeObj,
            'accounts[0]': `urn:li:sponsoredAccount:${adAccountId}`,
            ...additionalQueryItems,
            fields: 'pivotValues,dateRange,impressions',
            'sortBy.field': 'IMPRESSIONS',
            'sortBy.order': 'DESCENDING'
          }
        },
        {
          path: `adAccounts/${adAccountId}/adCampaigns`,
          query: {
            q: 'search',
            sortOrder: 'DESCENDING',
            pageSize: 1000
          }
        }
      ]
    }
  }
  return response
}

function getCampaignsReportRequestInfo({timeFrame, adPlatform, isDateRangeChange = false, adAccountId, isTeamsFilter = false, campaignIds, orgId}) {
  const response = {}
  if(adPlatform === 'meta') {
    let additionalQueryItems = {}
    if(['custom', 'last_90d'].includes(timeFrame.id)) {
      additionalQueryItems = {
        time_range: JSON.stringify({since : timeFrame.startValue, until : timeFrame.endValue})
      }
    } else {
      const selectedTimeFrame = getSelectedTimeFrame(timeFrame.id, adPlatform)
      additionalQueryItems = { date_preset: selectedTimeFrame,}
    }
    if(isTeamsFilter && Array.isArray(campaignIds)) {
      additionalQueryItems = {
        ...additionalQueryItems,
        filtering: JSON.stringify([{
          field: 'campaign.id',
          operator: 'IN',
          value: campaignIds || []
        }]),
      }
    }
    response.path = ['miscs', 'get-meta-analytics']
    response.jsonBody = {
      requests: [
        {
          path: `act_${adAccountId}/insights`,
          query: {
            level: 'campaign',
            fields: 'ad_id, ad_name, campaign_id, campaign_name, created_time, objective, frequency, impressions, spend, reach, ctr, actions, results',
            ...additionalQueryItems,
            limit: 100,
            sort:'created_time_descending',
          }
        },
        {
          path: `act_${adAccountId}/insights`,
          query: {
            level: 'account',
            fields: 'date_start,account_currency, impressions, spend, reach, ctr, clicks, actions',
            ...additionalQueryItems,
            time_increment:1,
            limit: 100,
            sort:'impressions_descending',
          }
        },
        {
          path: `act_${adAccountId}/campaigns`,
          query: {
            fields: 'campaign_id, effective_status, created_time',
            ...additionalQueryItems,
            limit: 100,
          }
        },
      ]
    }
    if(!isDateRangeChange) {
      response.jsonBody.requests.push({
        path: `act_${adAccountId}`,
        query: {
          fields: 'currency,timezone_name,timezone_id',
        }
      })
    }
  } else if(adPlatform === 'google') {
    let customWhereClause = ''
    if(['custom', 'last_90d'].includes(timeFrame.id)) {
      customWhereClause = `WHERE segments.date BETWEEN '${timeFrame.startValue}' AND '${timeFrame.endValue}'`
    } else {
      const selectedTimeFrame = getSelectedTimeFrame(timeFrame.id, adPlatform)
      customWhereClause = `WHERE segments.date DURING ${selectedTimeFrame}`
    }

    if(isTeamsFilter && Array.isArray(campaignIds)) {
      if(campaignIds.length === 0) {
        campaignIds = [0]
      }
      customWhereClause = customWhereClause + ` AND campaign.id IN (${campaignIds.join(',')})`
    }

    const googleAdCampaignLimit = orgId && AppHelper.getSetting(orgId, 'GOOGLE_AD_CAMPAIGNS_LIMIT') || 100
    response.path = ['miscs', 'get-google-ads-analytics']
    response.jsonBody = {
      requests: [
        {
          path: `${adAccountId}/googleAds:search`,
          body: {
            query: `SELECT campaign.id,campaign.name,campaign.advertising_channel_type,campaign.primary_status,metrics.impressions,metrics.cost_micros,metrics.clicks,metrics.unique_users,metrics.ctr,metrics.conversions FROM campaign ${customWhereClause} ORDER BY campaign.primary_status ASC,metrics.impressions DESC LIMIT ${googleAdCampaignLimit}`
          }
        },
        {
          path: `${adAccountId}/googleAds:search`,
          body: {
            query: `SELECT segments.date,campaign.id,metrics.impressions,metrics.cost_micros,metrics.clicks,metrics.unique_users,metrics.ctr,metrics.conversions FROM campaign ${customWhereClause} ORDER BY segments.date DESC LIMIT 1000`
          }
        },
      ],
    }
    if(!isDateRangeChange) {
      response.jsonBody.requests.push( {
        path: `${adAccountId}/googleAds:search`,
        body: {
          query: 'SELECT customer.time_zone,customer.currency_code,metrics.optimization_score_url FROM customer LIMIT 1'
        }
      })
    }
  } else if(adPlatform === 'linkedin') {
    const additionalQueryItems = {}
    if(isTeamsFilter && Array.isArray(campaignIds)) {
      campaignIds.forEach((campaignId, index)=>{
        const key = `campaigns[${index}]`
        additionalQueryItems[key] = `urn:li:sponsoredCampaign:${campaignId}`
      })

    }
    const dateRangeObj = CampaignReportsHelper.generateLinkedInDateRange(timeFrame)
    response.path = ['miscs', 'get-linkedin-ads-analytics']
    response.jsonBody = {
      requests: [
        {
          path: 'adAnalytics',
          query: {
            q: 'analytics',
            pivot: 'CAMPAIGN',
            timeGranularity: 'ALL',
            ...dateRangeObj,
            'accounts[0]': `urn:li:sponsoredAccount:${adAccountId}`,
            ...additionalQueryItems,
            fields: CampaignReportsHelper.LINKEDIN_ANALYTICS_FIELDS,
            'sortBy.field': 'IMPRESSIONS',
            'sortBy.order': 'DESCENDING'
          }
        },
        {
          path: `adAccounts/${adAccountId}/adCampaigns`,
          query: {
            q: 'search',
            sortOrder: 'DESCENDING',
            pageSize: 1000
          }
        },
        (isTeamsFilter && Array.isArray(campaignIds)) ?
          {
            path: 'adAnalytics',
            query: {
              q: 'analytics',
              pivot: 'CAMPAIGN',
              timeGranularity: 'DAILY',
              ...dateRangeObj,
              'accounts[0]': `urn:li:sponsoredAccount:${adAccountId}`,
              ...additionalQueryItems,
              fields: CampaignReportsHelper.LINKEDIN_ANALYTICS_FIELDS
            }
          } :
          {
            path: 'adAnalytics',
            query: {
              q:'analytics',
              pivot:'ACCOUNT',
              timeGranularity:'DAILY',
              ...dateRangeObj,
              'accounts[0]': `urn:li:sponsoredAccount:${adAccountId}`,
              fields: CampaignReportsHelper.LINKEDIN_ANALYTICS_FIELDS
            }
          }
      ]
    }
    if(!isDateRangeChange) {
      response.jsonBody.requests.push({
        path: `adAccounts/${adAccountId}`,
        query: {
          fields: 'id,name,currency',
        }
      })
    }
  }
  return response
}

function getAdsReportRequestInfo({campaignId, timeFrame, adPlatform, adAccountId}) {
  const response = {}
  if(campaignId) {
    if(adPlatform === 'meta') {
      let insightsFieldsForDateRange = ''
      if(['custom', 'last_90d'].includes(timeFrame.id)) {
        const selectedTimeFrame = JSON.stringify({since : timeFrame.startValue, until : timeFrame.endValue})
        insightsFieldsForDateRange = `insights.time_range(${selectedTimeFrame}){impressions,reach,frequency,spend,ctr,actions,results}`
      } else {
        const selectedTimeFrame = getSelectedTimeFrame(timeFrame.id, adPlatform)
        insightsFieldsForDateRange = `insights.date_preset(${selectedTimeFrame}){impressions,reach,frequency,spend,ctr,actions,results}`
      }
      response.path = ['miscs', 'get-meta-analytics']
      response.jsonBody = {
        requests: [
          {
            path: `${campaignId}/ads`,
            query: {
              fields: `id,name,effective_status,created_time,campaign{name,objective},adset{targeting{age_min,age_max,genders,geo_locations{places{name,radius,country}},flexible_spec{interests},behaviors}},creative{effective_object_story_id,instagram_permalink_url},${insightsFieldsForDateRange}`,
              limit: 100,
            }
          }
        ]
      }
    } else if(adPlatform === 'google') {
      let customWhereClause = ''
      if(['custom', 'last_90d'].includes(timeFrame.id)) {
        customWhereClause = `WHERE campaign.id = ${campaignId} AND segments.date BETWEEN '${timeFrame.startValue}' AND '${timeFrame.endValue}'`
      } else {
        const selectedTimeFrame = getSelectedTimeFrame(timeFrame.id, adPlatform)
        customWhereClause = `WHERE campaign.id = ${campaignId} AND segments.date DURING ${selectedTimeFrame}`
      }
      response.path = ['miscs', 'get-google-ads-analytics']
      response.jsonBody = {
        requests: [
          {
            path: `${adAccountId}/googleAds:search`,
            body: {
              query: `SELECT ad_group_ad.ad.id,ad_group_ad.ad.name,ad_group_ad.primary_status,ad_group_ad.resource_name,ad_group.id,ad_group.name,ad_group_ad.ad.responsive_search_ad.headlines,ad_group_ad.ad.responsive_search_ad.descriptions,ad_group_ad.ad.final_urls,campaign.id,campaign.name,ad_group_ad.ad.type,metrics.impressions,metrics.clicks,metrics.cost_micros,metrics.conversions FROM ad_group_ad ${customWhereClause} ORDER BY ad_group_ad.primary_status ASC,metrics.impressions DESC LIMIT 100`
            }
          }
        ],
      }
    } else if(adPlatform === 'linkedin') {
      const dateRangeObj = CampaignReportsHelper.generateLinkedInDateRange(timeFrame)
      response.path = ['miscs', 'get-linkedin-ads-analytics']
      response.jsonBody = {
        requests: [
          {
            path: 'adAnalytics',
            query: {
              q: 'analytics',
              pivot: 'CREATIVE',
              timeGranularity: 'ALL',
              ...dateRangeObj,
              'campaigns[0]': `urn:li:sponsoredCampaign:${campaignId}`,
              fields: CampaignReportsHelper.LINKEDIN_ANALYTICS_FIELDS,
              'sortBy.field': 'IMPRESSIONS',
              'sortBy.order': 'DESCENDING'
            }
          },
          {
            path: `adAccounts/${adAccountId}/creatives`,
            query: {
              q: 'criteria',
              campaigns: `urn:li:sponsoredCampaign:${campaignId}`
            }
          }
        ]
      }
    }
  }
  return response
}

function getTimeFrameData(timeFrame) {
  let timeFrameObj = {id: timeFrame.id, startValue: null, endValue: null}
  if(timeFrame.id === 'custom' || timeFrame.id === 'last_90d') {
    timeFrameObj = {id: timeFrame.id, startValue: moment(timeFrame.startDate).format('YYYY-MM-DD'), endValue: moment(timeFrame.endDate).format('YYYY-MM-DD')}
  }
  return timeFrameObj
}

function generateAdAccountsFromCDPSettings(adAccountsSettings, adPlatform) {
  let adAccounts = []
  if (typeof adAccountsSettings === 'string' && adAccountsSettings.trim() !== '') {
    adAccounts = adAccountsSettings
      .split(',')
      .map(entry => entry.trim())
      .filter(entry => entry.length > 0)
      .map(config => {
        const parts = config.split('=').map(p => p.trim())

        const platform = adPlatform ? adPlatform.charAt(0).toUpperCase() + adPlatform.slice(1).toLowerCase() : ''
        if (parts.length === 2 && parts[0] && parts[1]) {
          return { key: `${adPlatform}-${parts[1]}`, id: parts[1], label: `${parts[0]} (${parts[1]})`, platform: adPlatform}
        } else if (parts.length === 1 && /^\d+$/.test(parts[0])) {
          return { key: `${adPlatform}-${parts[0]}`, id: parts[0], label: `${platform} (${parts[0]})`, platform: adPlatform }
        }
        return null
      })
      .filter(item => item !== null)
  }

  return adAccounts
}

function generateTeamsFromCDPSettings(teamsSettings) {
  const teams = [{ key: 'all', label: 'All', prefix: '' }];

  if (typeof teamsSettings === 'string' && teamsSettings.trim() !== '') {
    const parsed = teamsSettings
      .split('|')
      .map(group => group.trim())
      .filter(Boolean)
      .map(group => {
        const item = {};

        group
          .split(';')
          .map(part => part.trim())
          .filter(Boolean)
          .forEach(pair => {
            const [rawKey, ...rawValue] = pair.split(':');
            if (!rawKey || !rawValue.length) return;

            const key = rawKey.trim();
            const value = rawValue.join(':').trim();

            item[key] = value;
          });

        return item;
      });

    teams.push(...parsed);
  }

  return teams;
}

function getExportFieldDef(options) {
  const {adPlatform, timeFrame} = options
  const { key: adPlatformKey, id: accountId, label: accountLabel, platform: accountType} = adPlatform
  function _getField(key, label, currentVal, currentLabel, placement, attribs = {}) {
    return {
      key,
      type: 'radio',
      label,
      options: [{key: currentVal, label: currentLabel}],
      v_required: {
        value: true,
        err: `Choose ${label}`,
      },
      placement,
      defaultValue: currentVal,
      ...attribs,
    }
  }
  const dateRange = DateRanges.find(dr => dr.id === timeFrame.id)
  const dateRangeLabel = timeFrame.id === 'custom' ? `${moment(timeFrame.startValue).format('YYYY-MM-DD')} to ${moment(timeFrame.endValue).format('YYYY-MM-DD')}` : dateRange.label
  const timeFrameId = timeFrame.id === 'last_90d' && ['meta','google'].includes(accountType) || accountType === 'linkedin' ? 'custom' : timeFrame.id
  let drStartDate, drEndDate
  if (accountType === 'linkedin') {
    const drRange = dateRange.range()
    drStartDate = moment(drRange.startDate).format('YYYY-MM-DD')
    drEndDate = moment(drRange.endDate).format('YYYY-MM-DD')
  }
  const dateFrom = drStartDate || moment(timeFrame.startValue).format('YYYY-MM-DD')
  const dateTo = drEndDate || moment(timeFrame.endValue).format('YYYY-MM-DD')
  const fieldDef = {
    title: Helper.getString('exportAdReport'),
    ctaButtonText: 'Export',
    steps: [
      {
        fields: [
          _getField('accountId', 'Account ID', accountId, accountId, 'left', {hidden: true}),
          _getField('accountType', 'Account Type', accountType, Helper.capitalizeFirstLetter(accountType), 'left', {hidden: true}),
          _getField('_account', 'Account', adPlatformKey, accountLabel, 'left'),
          _getField('dateFilter', 'Date', timeFrameId, dateRangeLabel, 'right'),
          _getField('dateFrom', 'Date From', dateFrom, dateFrom, 'left', {hidden: true, v_required: {value: false}}),
          _getField('dateTo', 'Date To', dateTo, dateTo, 'left', {hidden: true, v_required: {value: false}}),
        ]
      }
    ],
    disableAlwaysFormFields: ['accountId', 'accountType', '_account', 'dateFilter', 'dateFrom', 'dateTo'],
  }
  return fieldDef
}

function getAnalyzeFieldDef(options) {
  const {adPlatform, timeFrame} = options
  const { key: adPlatformKey, id: accountId, label: accountLabel, platform: accountType} = adPlatform
  function _getField(key, label, currentVal, currentLabel, placement, attribs = {}) {
    return {
      key,
      type: 'radio',
      label,
      options: [{key: currentVal, label: currentLabel}],
      v_required: {
        value: true,
        err: `Choose ${label}`,
      },
      placement,
      defaultValue: currentVal,
      ...attribs,
    }
  }
  const dateRange = DateRanges.find(dr => dr.id === timeFrame.id)
  const dateRangeLabel = 'Last 30 days'
  const timeFrameId = 'last_30d'
  const last30dDateRange = DateRanges.find(dr => dr.id === 'last_30d')
  const dateRangeData = last30dDateRange ? last30dDateRange.range() : null
  const dateFrom = dateRangeData ? moment(dateRangeData.startDate).format('YYYY-MM-DD') : moment().subtract(30, 'days').format('YYYY-MM-DD')
  const dateTo = dateRangeData ? moment(dateRangeData.endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
  const fieldDef = {
    title:'Analyse Ad Performance',
    ctaButtonText:'Confirm',
    steps:[
      {
        fields:[
          _getField('_account', 'Account', adPlatformKey, accountLabel, 'left'),
          _getField('dateFilter', 'Date', timeFrameId, dateRangeLabel, 'right'),
          _getField('dateFrom', 'Date From', dateFrom, dateFrom, 'left', { hidden: true, v_required: { value: false } }),
          _getField('dateTo', 'Date To', dateTo, dateTo, 'right', { hidden: true, v_required: { value: false } }),
          _getField('accountId', 'Account ID', accountId, accountId, 'left', { hidden: true, v_required: { value: false } }),
          _getField('accountType', 'Account Type', accountType, accountType, 'left', { hidden: true, v_required: { value: false } }),
        ]
      }
    ],
    disableAlwaysFormFields: ['_account', 'dateFilter', 'dateFrom', 'dateTo', 'accountId', 'accountType'],
  }
  return fieldDef
}

function getGeneratedAdReportFieldDef(options) {
  const { htmlContent = '' } = options

  return {
    title: 'Generated Ad Report',
    ctaButtonText: 'Close',
    steps: [
      {
        fields: [
          {
            key: 'reportContent',
            type: 'html',
            label: 'Report Analysis',
            htmlContent: htmlContent,
            disabled: true,
            v_required: {
              value: false,
            },
            placement: 'left'
          },
        ]
      }
    ]
  }
}

function getCardsData(aggregatedStats, platform, isMobileView = false) {
  let cardsData = []
  if(aggregatedStats && platform) {
    if(!isMobileView) {
      if(platform === 'meta') {
        cardsData = [
          [
            {
              key: 'amountSpent',
              text: aggregatedStats.spend ? Helper.formatLargeNumber(aggregatedStats.spend) : 0,
              subText: 'Amount Spent',
              cardIndex: 1,
              padding: 'small',
              cardId: 'amountSpent'
            },
            {
              key: 'impressions',
              text: aggregatedStats.impressions ? Helper.formatLargeNumber(aggregatedStats.impressions) : 0,
              subText: 'Impressions',
              cardIndex: 2,
              padding: 'small',
              cardId: 'impressions'
            },
            {
              key: 'reach',
              text: aggregatedStats.reach ? Helper.formatLargeNumber(aggregatedStats.reach) : 0,
              subText: 'Reach',
              cardIndex: 4,
              padding: 'small',
              cardId: 'reach'
            },
            {
              key: 'postEngagements',
              text: aggregatedStats.postEngagements ? Helper.formatLargeNumber(aggregatedStats.postEngagements) : 0,
              subText: 'Post Engagements',
              cardIndex: 5,
              padding: 'small',
              cardId: 'postEngagements'
            }
          ],
          [
            {
              key: 'linkClicks',
              text: aggregatedStats.linkClicks ? Helper.formatLargeNumber(aggregatedStats.linkClicks) : 0,
              subText: 'Link Clicks',
              cardIndex: 10,
              padding: 'small',
              cardId: 'linkClicks'
            },
            {
              key: 'conversationsStarted',
              text: aggregatedStats.conversationsStarted ? Helper.formatLargeNumber(aggregatedStats.conversationsStarted) : 0,
              subText: 'Msg Leads',
              cardIndex: 3,
              padding: 'small',
              cardId: 'conversationsStarted'
            },
            {
              key: 'metaLeads',
              text: aggregatedStats.metaLeads ? Helper.formatLargeNumber(aggregatedStats.metaLeads) : 0,
              subText: 'Meta Leads',
              cardIndex: 7,
              padding: 'small',
              cardId: 'metaLeads'
            },
            {
              key: 'websiteLeads',
              text: aggregatedStats.websiteLeads ? Helper.formatLargeNumber(aggregatedStats.websiteLeads) : 0,
              subText: 'Web Leads',
              cardIndex: 11,
              padding: 'small',
              cardId: 'websiteLeads'
            },
            {
              key: 'callsPlaced',
              text: aggregatedStats.callsPlaced ? Helper.formatLargeNumber(aggregatedStats.callsPlaced) : 0,
              subText: 'Calls Placed',
              cardIndex: 15,
              padding: 'small',
              cardId: 'callsPlaced'
            },
            {
              key: 'ctr',
              text: aggregatedStats.ctr ? `${aggregatedStats.ctr.toFixed(2)}%` : '0%',
              subText: 'CTR',
              cardIndex: 8,
              padding: 'small',
              cardId: 'ctr'
            }
          ]
        ]
      } else if(platform === 'google') {
        cardsData = [
          [
            {
              key: 'amountSpent',
              text: aggregatedStats.spend ? Helper.formatLargeNumber(aggregatedStats.spend) : 0,
              subText: 'Amount Spent',
              cardIndex: 1,
              padding: 'small',
              cardId: 'amountSpent'
            },
            {
              key: 'impressions',
              text: aggregatedStats.impressions ? Helper.formatLargeNumber(aggregatedStats.impressions) : 0,
              subText: 'Impressions',
              cardIndex: 2,
              padding: 'small',
              cardId: 'impressions'
            },
            {
              key: 'ctr',
              text: aggregatedStats.ctr ? `${aggregatedStats.ctr.toFixed(2)}%` : '0%',
              subText: 'CTR',
              cardIndex: 4,
              padding: 'small',
              cardId: 'ctr'
            },
            {
              key: 'conversions',
              text: aggregatedStats.conversions ? Helper.formatLargeNumber(aggregatedStats.conversions) : 0,
              subText: 'Conversions',
              cardIndex: 3,
              padding: 'small',
              cardId: 'conversions'
            }
          ],
        ]
      } else if(platform === 'linkedin') {
        cardsData = [
          [
            {
              key: 'amountSpent',
              text: aggregatedStats.spend ? Helper.formatLargeNumber(aggregatedStats.spend) : 0,
              subText: 'Amount Spent',
              cardIndex: 1,
              padding: 'small',
              cardId: 'amountSpent'
            },
            {
              key: 'impressions',
              text: aggregatedStats.impressions ? Helper.formatLargeNumber(aggregatedStats.impressions) : 0,
              subText: 'Impressions',
              cardIndex: 2,
              padding: 'small',
              cardId: 'impressions'
            },
            {
              key: 'ctr',
              text: aggregatedStats.ctr ? `${aggregatedStats.ctr.toFixed(2)}%` : '0%',
              subText: 'CTR',
              cardIndex: 4,
              padding: 'small',
              cardId: 'ctr'
            },
            {
              key: 'conversions',
              text: aggregatedStats.conversions ? Helper.formatLargeNumber(aggregatedStats.conversions) : 0,
              subText: 'Conversions',
              cardIndex: 3,
              padding: 'small',
              cardId: 'conversions'
            }
          ],
        ]
      }
    } else {
      if(platform === 'meta') {
        cardsData = [
          [
            {
              key: 'amountSpent',
              text: aggregatedStats.spend ? Helper.formatLargeNumber(aggregatedStats.spend) : 0,
              subText: 'Amount Spent',
              cardIndex: 1,
              padding: 'small',
              cardId: 'amountSpent'
            },
            {
              key: 'impressions',
              text: aggregatedStats.impressions ? Helper.formatLargeNumber(aggregatedStats.impressions) : 0,
              subText: 'Impressions',
              cardIndex: 2,
              padding: 'small',
              cardId: 'impressions'
            },
          ],
          [
            {
              key: 'reach',
              text: aggregatedStats.reach ? Helper.formatLargeNumber(aggregatedStats.reach) : 0,
              subText: 'Reach',
              cardIndex: 4,
              padding: 'small',
              cardId: 'reach'
            },
            {
              key: 'postEngagements',
              text: aggregatedStats.postEngagements ? Helper.formatLargeNumber(aggregatedStats.postEngagements) : 0,
              subText: 'Post Engagements',
              cardIndex: 5,
              padding: 'small',
              cardId: 'postEngagements'
            }
          ],
          [
            {
              key: 'linkClicks',
              text: aggregatedStats.linkClicks ? Helper.formatLargeNumber(aggregatedStats.linkClicks) : 0,
              subText: 'Link Clicks',
              cardIndex: 10,
              padding: 'small',
              cardId: 'linkClicks'
            },
            {
              key: 'conversationsStarted',
              text: aggregatedStats.conversationsStarted ? Helper.formatLargeNumber(aggregatedStats.conversationsStarted) : 0,
              subText: 'Msg Leads',
              cardIndex: 3,
              padding: 'small',
              cardId: 'conversationsStarted'
            }
          ],
          [
            {
              key: 'metaLeads',
              text: aggregatedStats.metaLeads ? Helper.formatLargeNumber(aggregatedStats.metaLeads) : 0,
              subText: 'Meta Leads',
              cardIndex: 7,
              padding: 'small',
              cardId: 'metaLeads'
            },
            {
              key: 'websiteLeads',
              text: aggregatedStats.websiteLeads ? Helper.formatLargeNumber(aggregatedStats.websiteLeads) : 0,
              subText: 'Web Leads',
              cardIndex: 11,
              padding: 'small',
              cardId: 'websiteLeads'
            },
          ],
          [
            {
              key: 'callsPlaced',
              text: aggregatedStats.callsPlaced ? Helper.formatLargeNumber(aggregatedStats.callsPlaced) : 0,
              subText: 'Calls Placed',
              cardIndex: 15,
              padding: 'small',
              cardId: 'callsPlaced'
            },
            {
              key: 'ctr',
              text: aggregatedStats.ctr ? `${aggregatedStats.ctr.toFixed(2)}%` : '0%',
              subText: 'CTR',
              cardIndex: 8,
              padding: 'small',
              cardId: 'ctr'
            }
          ]
        ]
      } else if(platform === 'google') {
        cardsData = [
          [
            {
              key: 'amountSpent',
              text: aggregatedStats.spend ? Helper.formatLargeNumber(aggregatedStats.spend) : 0,
              subText: 'Amount Spent',
              cardIndex: 1,
              padding: 'small',
              cardId: 'amountSpent'
            },
            {
              key: 'impressions',
              text: aggregatedStats.impressions ? Helper.formatLargeNumber(aggregatedStats.impressions) : 0,
              subText: 'Impressions',
              cardIndex: 2,
              padding: 'small',
              cardId: 'impressions'
            }
          ],
          [
            {
              key: 'ctr',
              text: aggregatedStats.ctr ? `${aggregatedStats.ctr.toFixed(2)}%` : '0%',
              subText: 'CTR',
              cardIndex: 4,
              padding: 'small',
              cardId: 'ctr'
            },
            {
              key: 'conversions',
              text: aggregatedStats.conversions ? Helper.formatLargeNumber(aggregatedStats.conversions) : 0,
              subText: 'Conversions',
              cardIndex: 3,
              padding: 'small',
              cardId: 'conversions'
            }
          ]
        ]
      } else if(platform === 'linkedin') {
        cardsData = [
          [
            {
              key: 'amountSpent',
              text: aggregatedStats.spend ? Helper.formatLargeNumber(aggregatedStats.spend) : 0,
              subText: 'Amount Spent',
              cardIndex: 1,
              padding: 'small',
              cardId: 'amountSpent'
            },
            {
              key: 'impressions',
              text: aggregatedStats.impressions ? Helper.formatLargeNumber(aggregatedStats.impressions) : 0,
              subText: 'Impressions',
              cardIndex: 2,
              padding: 'small',
              cardId: 'impressions'
            }
          ],
          [
            {
              key: 'ctr',
              text: aggregatedStats.ctr ? `${aggregatedStats.ctr.toFixed(2)}%` : '0%',
              subText: 'CTR',
              cardIndex: 4,
              padding: 'small',
              cardId: 'ctr'
            },
            {
              key: 'conversions',
              text: aggregatedStats.conversions ? Helper.formatLargeNumber(aggregatedStats.conversions) : 0,
              subText: 'Conversions',
              cardIndex: 3,
              padding: 'small',
              cardId: 'conversions'
            }
          ]
        ]
      }
    }
  }
  return cardsData
}

function getTeamsForAdPlatform(teams, adPlatform) {
  let filteredTeams = teams
  if(adPlatform && adPlatform.key && Array.isArray(teams) && teams.length > 0) {
    filteredTeams = filteredTeams.filter((team)=>{
      if(team && (!team.account || team.account === adPlatform.key)) {
        return true
      }
    })
  }
  return filteredTeams
}

export class CampaignReportsOrg extends BaseEntityPage {
  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.pageTitle = 'Ads'
    this.pageKey = 'adsReportOrg'
    this.timeFrame = 'this_month'
    this.toFetch = []
    this.noAdd = true
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('campaigns') },
      { title: this.pageTitle },
    ]

    this.adPlatforms = []
    this.teams = []
    this.isMobileView = Helper.isMobileView()
    this.isHeaderActionsHidden = this.isMobileView ? true : false
    this.apiData = {
      orgId: this.orgId,
    }
    this.headerActions = []
    if (AppHelper.isSettingEnabled(this.orgId, 'ADS_ANALYSE') && !this.isMobileView) {
      this.headerActions.push({
        label: 'Analyse',
        tooltip: 'Analyse',
        icon: 'auto_awesome',
        type: 'icon-label',
        onClick: () => {
          if (this.state.adPlatform && this.state.timeFrame) {
            this.openModalForAnalyze(this.state.adPlatform, this.state.timeFrame)
          } else {
            this.setState({
              customError: {
                type: 'ERROR',
                errMsg: 'Please select an ad platform and time frame first'
              }
            })
          }
        }
      })
    }
    if (AppHelper.isAdsExportEnabled(this.orgId)) {
      this.headerActions.push({
        label: 'Export',
        tooltip: 'Export',
        icon: 'download',
        type: 'icon-label',
        onClick: () => {
          this.apiData._isJob = true
          const fieldDef = getExportFieldDef({
            adPlatform: this.state.adPlatform,
            timeFrame: this.state.timeFrame,
          })
          this.setState({
            apiMethod: 'POST',
            apiEndPoint: ApiHelper.makeUrlPath2({
              ms: AppConfig.CDP_MS.ENDPOINT,
              paths: ['miscs', 'export-ad-report'],
              queryParams: { orgId: this.orgId }
            }),
          })
          this.openModalForAdd(fieldDef)
        }
      })
    }
  }

  renderHeaderbar() {
    const adPlatform = this.state.adPlatformSelected || this.state.adPlatform
    const savedHeaderActions = this.headerActions
    const headerActions = [...(this.headerActions || [])]
    const showReconnect = AppHelper.isSettingEnabled(this.orgId, 'LINKEDIN_ADS_RECONNECT')
    if (showReconnect && adPlatform && adPlatform.platform === 'linkedin' && !this.isMobileView) {
      headerActions.push({
        label: 'Reconnect',
        tooltip: 'Reconnect LinkedIn',
        icon: <div><LinkedInIcon style={{ fontSize: 20 }} /></div>,
        type: 'icon-label',
        onClick: () => this.handleConnectLinkedInButtonClick()
      })
    }
    this.headerActions = headerActions
    const view = super.renderHeaderbar()
    this.headerActions = savedHeaderActions
    return view
  }
  getResult(results, key) {
    const index = this.toFetch.findIndex(i => i.key === key)
    return (index >= 0 && index < results.length) ? results[index] : null
  }

  fetchItems() {
    this.apiStartTs = Helper.currentTs()
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      isOrderChanged: false,
      customError: null
    })
    const fcns = [];
    for (const f of this.toFetch) {
      fcns.push(function (callback) {
        ApiHelper.call(f, callback);
      })
    }
    async.parallel(fcns, async function (err, results) {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }
      if (this.onFetchSuccess) {
        if (this.toFetch.length > 0) {
          Helper.amplifyEvent({
            name: 'apiLoad',
            attributes: { path: this.props.match.path, orgId: this.orgId },
            metrics: { apiTimeMs: Helper.currentTs() - this.apiStartTs }
          })
        }
        await this.onFetchSuccess(results);
      }
    }.bind(this))
  }

  getAdAccountId(adPlatform) {
    const accountId = adPlatform && adPlatform.id
    return accountId
  }

  getCampaignReports(results, adPlatform) {
    let campaignReports = null
    let dateWiseCampaignReports = null
    let customerData = null
    if(results && adPlatform) {
      if(adPlatform === 'meta') {
        const campaignInsights = results[0]
        const accountInsights = results[1]
        const campaignsData = results[2]
        customerData = results[3]
        if (campaignInsights && campaignInsights.data && campaignsData && campaignsData.data) {
          campaignReports = getCampaignReportData(adPlatform,campaignInsights.data,campaignsData.data)
        }
        if(accountInsights && accountInsights.data) {
          dateWiseCampaignReports =  getDateWiseCampaignsReportData(accountInsights.data,adPlatform)
        }
      } else if(adPlatform === 'google') {
        const campaignInsights = results[0]
        const accountInsights = results[1]
        const customerDataResponse = results[2]
        if (campaignInsights && campaignInsights.results) {
          campaignReports = getCampaignReportData(adPlatform,campaignInsights.results)
        }
        if(accountInsights && accountInsights.results) {
          dateWiseCampaignReports = getDateWiseCampaignsReportData(accountInsights.results,adPlatform)
        }
        if(customerDataResponse && customerDataResponse.results && customerDataResponse.results.length > 0) {
          customerData = customerDataResponse.results[0]
        }
      } else if(adPlatform === 'linkedin') {
        const campaignInsights = results[0]
        const campaignsData = results[1]
        const accountInsights = results[2]
        customerData = results[3]
        if (campaignInsights && campaignInsights.elements && campaignsData && campaignsData.elements) {
          campaignReports = getCampaignReportData(adPlatform,campaignInsights.elements,campaignsData.elements)
        }
        if(accountInsights && accountInsights.elements) {
          dateWiseCampaignReports =  getDateWiseCampaignsReportData(accountInsights.elements,adPlatform)
        }
      }
    }
    return {campaignReports,dateWiseCampaignReports,customerData}
  }

  getCampaignData(results, adPlatform) {
    let campaignData = null
    if(results && adPlatform) {
      if(adPlatform === 'meta') {
        const campaignInsights = results[0]
        if (campaignInsights && campaignInsights.data) {
          campaignData =  campaignInsights.data.map(item => {
            return {
              campaignId: item.campaign_id,
              campaignName: item.campaign_name
            }
          })
        }
      } else if(adPlatform === 'google') {
        const campaignInsights = results[0]
        if (campaignInsights && campaignInsights.results) {
          campaignData = campaignInsights.results.map(item => {
            return {
              campaignId: item && item.campaign && item.campaign.id,
              campaignName: item && item.campaign && item.campaign.name,
            }
          })
        }
      } else if(adPlatform === 'linkedin') {
        const campaignInsights = results[0]
        const campaignsData = results[1]
        if (campaignInsights && campaignInsights.elements && campaignsData && campaignsData.elements) {
          campaignData = campaignInsights.elements.map(item => {
            const campaignId = item && Array.isArray(item.pivotValues) && item.pivotValues[0] && item.pivotValues[0].replace('urn:li:sponsoredCampaign:', '')
            if(campaignId) {
              const campaignDetails = campaignsData.elements.find(dataObj => Number(dataObj.id) === Number(campaignId))
              return {
                campaignId: campaignId,
                campaignName: campaignDetails.name || '',
              }
            }
          }).filter(a => !!a)
        }
      }
    }
    return campaignData
  }

  getAdsReport(results, campaignName) {
    let adsReport = null
    if(this.state.adPlatform && this.state.adPlatform.platform) {
      const platform = this.state.adPlatform.platform
      if(platform === 'meta') {
        const report = results[0]
        if (results && report && report) {
          report.data = report.data || []
          adsReport = getAdReportData(report.data,platform)
        }
      } else if(platform === 'google') {
        const report = results[0]
        if (results && report) {
          report.results = report.results || []
          adsReport = getAdReportData(report.results,platform,this.state.customerData)
        }
      } else if(platform === 'linkedin') {
        const adInsights = results[0]
        const adsData = results[1]
        if (results && adInsights && adInsights.elements && adInsights.elements.length > 0 && adsData.elements && adsData.elements.length > 0) {
          const report = CampaignReportsHelper.mergeLinkedInAdReports(adInsights.elements, adsData.elements)
          adsReport = getAdReportData(report,platform,this.state.customerData, campaignName)
        }
      }
    }
    return adsReport
  }
  openModalForAnalyze(adPlatform, timeFrame) {
    const fieldDef = getAnalyzeFieldDef({
      adPlatform: adPlatform,
      timeFrame: timeFrame,
    })
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'edit'

    const last30dDateRange = DateRanges.find(dr => dr.id === 'last_30d')
    const dateRangeData = last30dDateRange ? last30dDateRange.range() : null

    const dateFrom = dateRangeData ? moment(dateRangeData.startDate).format('YYYY-MM-DD') : moment().subtract(30, 'days').format('YYYY-MM-DD')
    const dateTo = dateRangeData ? moment(dateRangeData.endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')

    const formData = {
      _account: adPlatform.label,
      dateFilter: 'Last 30 days',
      dateFrom,
      dateTo,
      accountId: adPlatform.id,
      accountType: adPlatform.platform,
    }

    Helper.populateFormDefinitionValues(this.formDefinition, formData)

    this.setState({
      apiMethod: 'POST',
      apiData: {
        orgId: this.orgId,
        isAnalyze: true,
        adPlatform: adPlatform,
      },
      modalOpen: true
    });
  }

  async customSubmitForAnalyze(options) {
    const { formType, formData, caller } = options

    delete formData.isAnalyze

    if (formData && formData.accountId && formData.accountType) {
      try {
        caller.setState({
          inProcess: true,
          fetchState: ApiHelper.State.LOADING
        })

        const analysisResponse = await ApiHelper.callAwait({
          ms: AppConfig.CDP_MS.ENDPOINT,
          method: 'POST',
          paths: ['miscs', 'adanalytics'],
          queryParams: { orgId: this.orgId },
          jsonBody: {
            orgId: this.orgId,
            accountId: formData.accountId,
            accountType: formData.accountType
          }
        })

        const htmlContent = analysisResponse && analysisResponse.response && analysisResponse.response.html
          ? analysisResponse.response.html
          : '<p>No analysis data available</p>'

        this.setState({
          modalOpen: false,
          fetchState: ApiHelper.State.READY,
        }, () => {
          this.openModalForGeneratedAdReport(htmlContent)
        })

      } catch (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          inProcess: false,
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
        })
      }
    } else {
      this.setState({
        modalOpen: false,
        fetchState: ApiHelper.State.READY,
      })
    }
  }
  openModalForGeneratedAdReport(htmlContent) {
    const fieldDef = getGeneratedAdReportFieldDef({
      htmlContent: htmlContent,
    })

    this.formDefinition = fieldDef
    this.formDefinition.disableCTAButton = false
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, {
      reportContent: htmlContent
    })

    this.setState({
      apiMethod: 'POST',
      apiData: {
        orgId: this.orgId,
        isGeneratedAdReport: true,
      },
      modalOpen: true
    });
  }

  async customSubmitForGeneratedAdReport(options) {
    const { formType, formData, caller } = options

    delete formData.isGeneratedAdReport

    this.setState({
      modalOpen: false,
      fetchState: ApiHelper.State.READY,
    })
  }

  onFetchSuccess(results) {
    this.adPlatform = null
    const metaAdAccount = AppHelper.getSetting(this.orgId, 'META_AD_ACCOUNT_ID')
    const googleAdAccount = AppHelper.getSetting(this.orgId, 'GOOGLE_AD_ACCOUNT_ID')
    const linkedinAdAccount = AppHelper.getSetting(this.orgId, 'LINKEDIN_AD_ACCOUNT_ID')
    if(metaAdAccount) {
      const adPlatforms = generateAdAccountsFromCDPSettings(metaAdAccount, 'meta')
      this.adPlatforms.push(...adPlatforms)
      this.adPlatform = adPlatforms[0]
    }
    if(googleAdAccount) {
      const adPlatforms = generateAdAccountsFromCDPSettings(googleAdAccount, 'google')
      this.adPlatforms.push(...adPlatforms)
      if(!this.adPlatform) {
        this.adPlatform = adPlatforms[0]
      }
    }
    if(linkedinAdAccount) {
      const adPlatforms = generateAdAccountsFromCDPSettings(linkedinAdAccount, 'linkedin')
      this.adPlatforms.push(...adPlatforms)
      if(!this.adPlatform) {
        this.adPlatform = adPlatforms[0]
      }
    }

    this.team = null
    const teamsSettings = AppHelper.getSetting(this.orgId, 'AD_TEAMS')
    if(teamsSettings) {
      const teams = generateTeamsFromCDPSettings(teamsSettings)
      this.teams.push(...teams)
      this.team = teams[0]
    }

    const _url = new URL(document.location.href)
    const platformSearchParam = _url.searchParams.has('platform') && _url.searchParams.get('platform')
    if(platformSearchParam && this.adPlatforms) {
      this.adPlatform = this.adPlatforms.find(option => option.key === platformSearchParam) || {key: platformSearchParam, label: platformSearchParam}
    } else if(!platformSearchParam && this.adPlatform && this.adPlatform.key) {
      _url.searchParams.set('platform', this.adPlatform.key)
      const newUrl = _url.toString()
      if (window.location.href !== newUrl) {
        window.history.replaceState({}, '', newUrl);
      }
    }

    const teams = getTeamsForAdPlatform(this.teams,this.adPlatform)

    if(this.adPlatform && this.adPlatform.platform) {
      const campaignReportsRequestInfo = getCampaignsReportRequestInfo({timeFrame: getTimeFrameData({id: this.timeFrame}), adPlatform: this.adPlatform.platform, isDateRangeChange: false, adAccountId: this.getAdAccountId(this.adPlatform), orgId: this.orgId})
      const reqPath = (campaignReportsRequestInfo && campaignReportsRequestInfo.path) ? campaignReportsRequestInfo.path : []
      const reqJsonBody = (campaignReportsRequestInfo && campaignReportsRequestInfo.jsonBody) ? campaignReportsRequestInfo.jsonBody : {}

      ApiHelper.callAwait({
        ms:  this.ms, method: 'POST', paths: reqPath,
        queryParams: { orgId: this.orgId},
        jsonBody: reqJsonBody
      }).then(results => {
        if(results && results.status === 'NOT_CONNECTED') {
          this.setState({
            campaignReports: [],
            dateWiseCampaignReports: [],
            timeFrame: getTimeFrameData({id: this.timeFrame}),
            adPlatform : this.adPlatform,
            adPlatformSelected: (this.adPlatforms && this.adPlatforms.length > 0 ) && this.adPlatforms.find(option => option.key === this.adPlatform.key),
            teams: teams,
            team: this.team,
            teamSelected: (this.teams && this.teams.length > 0 ) && this.teams.find(option => option.key === this.team.key),
            adsModalOpen: false,
            customError: {type: results.status, errMsg: results.message},
            fetchState: ApiHelper.State.READY
          })
        } else if(results && results[1] && results[1].metadata && results[1].metadata.nextPageToken && this.adPlatform.platform === 'linkedin') {
          this.setState({
            campaignReports: [],
            dateWiseCampaignReports: [],
            timeFrame: getTimeFrameData({id: this.timeFrame}),
            adPlatform : this.adPlatform,
            adPlatformSelected: (this.adPlatforms && this.adPlatforms.length > 0 ) && this.adPlatforms.find(option => option.key === this.adPlatform.key),
            teams: teams,
            team: this.team,
            teamSelected: (this.teams && this.teams.length > 0 ) && this.teams.find(option => option.key === this.team.key),
            adsModalOpen: false,
            customError: {type: 'ERROR', errMsg: Helper.getString('unableToGenerateAdReport')},
            fetchState: ApiHelper.State.READY
          })
        } else {
          const {campaignReports, dateWiseCampaignReports, customerData} = this.getCampaignReports(results, this.adPlatform.platform)
          this.setState({
            campaignReports: campaignReports,
            dateWiseCampaignReports: dateWiseCampaignReports,
            customerData: customerData,
            timeFrame: getTimeFrameData({id: this.timeFrame}),
            adPlatform : this.adPlatform,
            adPlatformSelected: (this.adPlatforms && this.adPlatforms.length > 0 ) && this.adPlatforms.find(option => option.key === this.adPlatform.key),
            teams: teams,
            team: this.team,
            teamSelected: (this.teams && this.teams.length > 0 ) && this.teams.find(option => option.key === this.team.key),
            adsModalOpen: false,
            customError: null,
            fetchState: ApiHelper.State.READY
          })
        }
      }).catch(err => {
        this.setState({
          campaignReports: [],
          dateWiseCampaignReports: [],
          timeFrame: getTimeFrameData({id: this.timeFrame}),
          adPlatform : this.adPlatform,
          adPlatformSelected: (this.adPlatforms && this.adPlatforms.length > 0 ) && this.adPlatforms.find(option => option.key === this.adPlatform.key),
          teams: teams,
          team: this.team,
          teamSelected: (this.teams && this.teams.length > 0 ) && this.teams.find(option => option.key === this.team.key),
          adsModalOpen: false,
          customError: null,
          fetchState: ApiHelper.State.READY
        })
      })
    } else {
      this.setState({
        campaignReports: [],
        dateWiseCampaignReports: [],
        timeFrame: getTimeFrameData({id: this.timeFrame}),
        adPlatform:  this.adPlatform,
        teams: teams,
        team: this.team,
        teamSelected: (this.teams && this.teams.length > 0 ) && this.teams.find(option => option.key === this.team.key),
        adsModalOpen: false,
        customError: null,
        fetchState: ApiHelper.State.READY
      })
    }
  }

  fullWidthCondition(fullWidthDialog) {
    if (fullWidthDialog) {
      return true
    }
    if (window.innerWidth && window.innerWidth < 480) {
      return true
    }
    return false
  }

  onCloseAdsModal() {
    this.setState({
      adsModalOpen: false,
      adsReport: null,
      customError: null,
    });
  }

  adsTableActions(headers, rows, rowIndex) {
    const adId = rows[0]
    let adName = rows[1]
    const actions = []
    let sources = []
    if(this.state.adPlatform && this.state.adPlatform.platform) {
      const platform = this.state.adPlatform.platform
      if(platform === 'meta') {
        sources = ['FACEBOOK','INSTAGRAM']
        const facebookPostLink = rows[11]
        const instgramPostLink = rows[12]
        const audienceData = rows[14]

        // TODO: Workflow for collapsable row
        // actions.push(
        //   <Tooltip title={'View Audience'} classes={{ popper: css(Styles.tooltip) }}>
        //     <IconButton
        //       disableRipple
        //       className={css(AppStyles.entityTableLinkIcon)}
        //       onClick={() => {
        //         if(this.state.showRowCollapse) {
        //           this.setState({
        //             showRowCollapse : false,
        //             collapseRowIndex : null
        //             customError: null,
        //           })
        //         } else {
        //           this.setState({
        //             showRowCollapse : true,
        //             collapseRowIndex :rowIndex
        //             customError: null,
        //           })
        //         }
        //       }}
        //     >
        //       <InfoOutlinedIcon style={{fontSize: 26}}/>
        //     </IconButton>
        //   </Tooltip>)

        if(facebookPostLink) {
          actions.push(
            <Tooltip title={'View Facebook Post'} classes={{ popper: css(Styles.tooltip) }}>
              <IconButton
                disableRipple
                className={css(AppStyles.entityTableLinkIcon)}
                onClick={() => window.open(facebookPostLink, '_blank')}
              >
                <FacebookIcon style={{fontSize: 26}}/>
              </IconButton>
            </Tooltip>)
        }

        if(instgramPostLink) {
          actions.push(
            <Tooltip title={'View Instagram Post'} classes={{ popper: css(Styles.tooltip) }}>
              <IconButton
                disableRipple
                className={css(AppStyles.entityTableLinkIcon)}
                onClick={() => window.open(instgramPostLink, '_blank')}
              >
                <InstagramIcon style={{fontSize: 26}}/>
              </IconButton>
            </Tooltip>)
        }
      } else if(platform === 'google') {
        adName = (rows[1] && rows[1].headlines && rows[1].headlines.length > 0) ? rows[1].headlines[0] : adId
        sources = ['GOOGLE']
        const adPreviewLink = rows[11]
        if(adPreviewLink) {
          actions.push(
            <Tooltip title={'Preview'} classes={{ popper: css(Styles.tooltip) }}>
              <IconButton
                disableRipple
                className={css(AppStyles.entityTableLinkIcon)}
                onClick={() => window.open(adPreviewLink, '_blank')}
              >
                <DesktopWindowsIcon style={{fontSize: 26}}/>
              </IconButton>
            </Tooltip>)
        }
      } else if(platform === 'linkedin') {
        sources = ['LINKEDIN']
        const adPreviewLink = rows[9]
        if(adPreviewLink) {
          actions.push(
            <Tooltip title={'View LinkedIn Post'} classes={{ popper: css(Styles.tooltip) }}>
              <IconButton
                disableRipple
                className={css(AppStyles.entityTableLinkIcon)}
                onClick={() => window.open(adPreviewLink, '_blank')}
              >
                <LinkedInIcon style={{fontSize: 28}}/>
              </IconButton>
            </Tooltip>)
        }
      }
    }

    let date = null
    let otherQueryParams = ''
    const timeZone = this.getAccountTimezone()
    if(this.state.timeFrame && this.state.timeFrame.id) {
      date = this.state.timeFrame.id
      if(date === 'custom' && this.state.timeFrame.startValue && this.state.timeFrame.endValue) {
        const tz = timeZone || Helper.getLocalTimezone()
        const startDate = moment.tz(this.state.timeFrame.startValue, 'YYYY-MM-DD', tz).startOf('day').valueOf()
        const endDate = moment.tz(this.state.timeFrame.endValue, 'YYYY-MM-DD', tz).endOf('day').valueOf()
        otherQueryParams = `&gteCreatedTs=${startDate}&lteCreatedTs=${endDate}`
      }
    }

    const adViewContactsSettingKey = {
      meta: 'META_ADS_AD_VIEW_CONTACTS',
      google: 'GOOGLE_ADS_AD_VIEW_CONTACTS',
      linkedin: 'LINKEDIN_ADS_AD_VIEW_CONTACTS',
    }[this.state.adPlatform && this.state.adPlatform.platform]
    const isAdViewContactsHidden = !!adViewContactsSettingKey && !AppHelper.isSettingEnabled(this.orgId, adViewContactsSettingKey)
    if(adId && sources.length > 0 && date && !isAdViewContactsHidden) {
      actions.push(
        <Tooltip title={'View Contacts'} classes={{ popper: css(Styles.tooltip) }}>
          <IconButton
            disableRipple
            className={css(AppStyles.entityTableLinkIcon)}
            onClick={() => window.open(`/admin/orgs/${this.orgId}/crm-contacts?slxAdId=${adId}&_labelForSlxAdId=${adName}` , '_blank')}
          >
            <PersonOutlineOutlinedIcon style={{fontSize: 26}}/>
          </IconButton>
        </Tooltip>)
    }

    return actions.length > 0 ? actions : null
  }

  renderAdsModal() {
    const fullWidthDialog = (this.props.fullWidthDialog && window.innerWidth > 480)
    if(this.state.adsReport && this.state.adPlatform && this.state.adPlatform.platform) {
      const adsReportData = this.state.adsReport
      const report = generateAdsReport(adsReportData,this.state.adPlatform.platform)
      return(<Dialog
        open={this.state.adsModalOpen}
        fullWidth={true}
        fullScreen={this.fullWidthCondition(fullWidthDialog)}
        classes={{
          root: css(Styles.customRoot),
          paper: css(Styles.customPaper, AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar),
        }}
        maxWidth='lg'
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{(adsReportData.length > 0 && adsReportData[0].campaignName) ? adsReportData[0].campaignName : 'Ads'}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseAdsModal.bind(this)} disabled={this.state.inProcess}>
            <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
              <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
            </svg>
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <TableCard item={{data: report, maxRows: 100}} isModalTable={true} tableRowActions={this.adsTableActions.bind(this)} showRowCollapse={this.state.showRowCollapse}  collapseRowIndex={this.state.collapseRowIndex}/>
        </div>
      </Dialog>)
    }
  }

  handleCampaignClick(headers, rows) {
    const campaignId = rows[0]
    const campaignName = rows[1]
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
      customError: null,
    })

    if(campaignId && this.state.adPlatform && this.state.adPlatform.platform) {
      const adsReportRequestInfo = getAdsReportRequestInfo({campaignId: campaignId, timeFrame: this.state.timeFrame, adPlatform: this.state.adPlatform.platform, adAccountId: this.getAdAccountId(this.state.adPlatform)})
      const reqPath = (adsReportRequestInfo && adsReportRequestInfo.path) ? adsReportRequestInfo.path : []
      const reqJsonBody = (adsReportRequestInfo && adsReportRequestInfo.jsonBody) ? adsReportRequestInfo.jsonBody : {}
      ApiHelper.callAwait({
        ms:  this.ms, method: 'POST', paths: reqPath,
        queryParams: { orgId: this.orgId},
        jsonBody: reqJsonBody
      }).then(results => {
        if(results && results.status === 'NOT_CONNECTED') {
          this.setState({
            adsModalOpen: true,
            adsReport: [],
            customError: {type: results.status, errMsg: results.message},
            fetchState: ApiHelper.State.READY,
            loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
          })
        } else {
          const adsReport = this.getAdsReport(results, campaignName)
          this.setState({
            adsModalOpen: true,
            adsReport: adsReport || [],
            customError: null,
            fetchState: ApiHelper.State.READY,
            loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
          })
        }
      }).catch(err => {
        this.setState({
          adsModalOpen: true,
          adsReport: [],
          customError: null,
          fetchState: ApiHelper.State.READY,
          loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
        })
      })
    } else {
      this.setState({
        adsModalOpen: true,
        adsReport: [],
        customError: null,
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
      })
    }
  }

  allCampaignsTableActions(headers, rows) {
    const campaignId = rows[0]
    const campaignName = rows[1]
    const actions = []
    let sources = []
    const formatCampgainType = type => type.replace(/_/g, ' ').toLowerCase()
    const platform = this.state.adPlatform && this.state.adPlatform.platform

    let hideDrillDown = false
    if(platform) {
      if(platform === 'google') {
        sources = ['GOOGLE']
        const drillDownDisabledCampaignTypes = ['UNSPECIFIED','UNKNOWN','DISPLAY','SHOPPING','HOTEL','VIDEO','MULTI_CHANNEL','LOCAL','SMART','PERFORMANCE_MAX','LOCAL_SERVICES','TRAVEL','DEMAND_GEN']
        hideDrillDown = drillDownDisabledCampaignTypes.some(type => formatCampgainType(type) === formatCampgainType(rows[3]));
      } else if(platform === 'meta') {
        sources = ['FACEBOOK','INSTAGRAM']
      } else if(platform === 'linkedin') {
        sources = ['LINKEDIN']
      }
    }
    if(!hideDrillDown) {
      actions.push(
        <Tooltip title={'View Ads'} classes={{ popper: css(Styles.tooltip) }}>
          <IconButton
            disableRipple
            className={css(AppStyles.entityTableLinkIcon)}
            onClick={() => this.handleCampaignClick(headers, rows)}
          >
            <ArrowForwardIosIcon style={{fontSize: 22}}/>
          </IconButton>
        </Tooltip>)
    }

    let date = null
    let otherQueryParams = ''
    const timeZone = this.getAccountTimezone()
    if(this.state.timeFrame && this.state.timeFrame.id) {
      date = this.state.timeFrame.id
      if(date === 'custom' && this.state.timeFrame.startValue && this.state.timeFrame.endValue) {
        const tz = timeZone || Helper.getLocalTimezone()
        const startDate = moment.tz(this.state.timeFrame.startValue, 'YYYY-MM-DD', tz).startOf('day').valueOf()
        const endDate = moment.tz(this.state.timeFrame.endValue, 'YYYY-MM-DD', tz).endOf('day').valueOf()
        otherQueryParams = `&gteCreatedTs=${startDate}&lteCreatedTs=${endDate}`
      }
    }

    let utmId = campaignId
    if(platform === 'linkedin' && Array.isArray(this.state.campaignReports)) {
      const matchedCampaign = this.state.campaignReports.find(item => String(item.campaignId) === String(campaignId))
      if(matchedCampaign && matchedCampaign.campaignGroupId) {
        utmId = matchedCampaign.campaignGroupId
      }
    }

    if(utmId && sources.length > 0 && date) {
      actions.push(
        <Tooltip title={'View Contacts'} classes={{ popper: css(Styles.tooltip) }}>
          <IconButton
            disableRipple
            className={css(AppStyles.entityTableLinkIcon)}
            onClick={() => window.open(`/admin/orgs/${this.orgId}/crm-contacts?utmId=${utmId}&_labelForUtmId=${campaignName}` , '_blank')}
          >
            <PersonOutlineOutlinedIcon style={{fontSize: 26}}/>
          </IconButton>
        </Tooltip>)
    }

    return actions.length > 0 ? actions : null
  }

  getAccountCurrency() {
    let currency = null
    if(this.state.adPlatform && this.state.adPlatform.platform) {
      const platform = this.state.adPlatform.platform
      if(platform === 'meta') {
        currency = this.state.customerData && this.state.customerData.currency
      } else if(platform === 'google') {
        currency = this.state.customerData && this.state.customerData.customer && this.state.customerData.customer.currencyCode
      } else if(platform === 'linkedin') {
        currency = this.state.customerData && this.state.customerData.currency
      }
    }
    return currency
  }

  getAccountTimezone() {
    let timeZone = Helper.getLocalTimezone()
    if(this.state.adPlatform && this.state.adPlatform.platform) {
      const platform = this.state.adPlatform.platform
      if(platform === 'meta') {
        timeZone = this.state.customerData && this.state.customerData.timezone_name
      } else if(platform === 'google') {
        timeZone = this.state.customerData && this.state.customerData.customer && this.state.customerData.customer.timeZone
      } else if(platform === 'linkedin') {
        timeZone = 'UTC'
      }
    }
    return timeZone
  }

  onAdPlatformAutoCompleteChange = (value) => {
    const url = new URL(window.location)
    const currentPlatform = url.searchParams.get('platform')
    if (currentPlatform !== value.key) {
      url.searchParams.set('platform', value.key)
      const newUrl = url.toString()
      if (window.location.href !== newUrl) {
        window.history.replaceState({}, '', newUrl);
      }
    }
    this.reFetchReport({timeFrame: this.state.timeFrame, adPlatform: value, team: this.state.team, isDateRangeChange: false})
  }

  onTeamsAutoCompleteChange = (value) => {
    this.reFetchReport({timeFrame: this.state.timeFrame, adPlatform: this.state.adPlatform, team: value, isDateRangeChange: false})
  }

  onDateRangeChange(dateRangeValues) {
    const timeFrame = getTimeFrameData(dateRangeValues)
    this.reFetchReport({timeFrame: timeFrame, adPlatform: this.state.adPlatform, team: this.state.team, isDateRangeChange: true})
  }

  handleRefreshButtonClick () {
    const adPlatform = this.state.adPlatform && JSON.parse(JSON.stringify(this.state.adPlatform))
    const timeFrame = this.state.timeFrame && JSON.parse(JSON.stringify(this.state.timeFrame))
    const team = this.state.team && JSON.parse(JSON.stringify(this.state.team))
    this.reFetchReport({timeFrame: timeFrame, adPlatform: adPlatform, team: this.state.team, isDateRangeChange: false})
  }

  async getAllCampaigns(adPlatform, timeFrame) {
    const campaignReportsRequestInfo = getCampaignDataRequestInfo({timeFrame, adPlatform: adPlatform.platform, adAccountId: this.getAdAccountId(adPlatform)})
    const reqPath = (campaignReportsRequestInfo && campaignReportsRequestInfo.path) ? campaignReportsRequestInfo.path : []
    const reqJsonBody = (campaignReportsRequestInfo && campaignReportsRequestInfo.jsonBody) ? campaignReportsRequestInfo.jsonBody : {}

    const results = await ApiHelper.callAwait({
      ms: this.ms,
      method: 'POST',
      paths: reqPath,
      queryParams: { orgId: this.orgId },
      jsonBody: reqJsonBody
    })

    if (results && results.status !== 'NOT_CONNECTED') {
      const campaginData = this.getCampaignData(results, adPlatform.platform)
      return campaginData || []
    }

    return []
  }


  async reFetchReport({timeFrame, adPlatform, team, isDateRangeChange}) {
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
      customError: null,
    })

    if(timeFrame && adPlatform && adPlatform.platform) {
      let campaignIds = []
      let isTeamsFilter = false

      const teams =  getTeamsForAdPlatform(this.teams,adPlatform)

      if(team && team.key) {
        const isValidTeam = teams.some(teamObj => teamObj.key === team.key)
        if(!isValidTeam) {
          team = this.team
        }
      }

      if(team && team.key !== 'all') {
        isTeamsFilter = true
        const campaigns = await this.getAllCampaigns(adPlatform, timeFrame)
        campaignIds = campaigns.map((campaign)=>{
          if(team.prefix && campaign && campaign.campaignName && campaign.campaignName.startsWith(team.prefix)) {
            return campaign.campaignId
          }
        }).filter(a => !!a)
      }
      if(!isTeamsFilter || (isTeamsFilter && Array.isArray(campaignIds) && campaignIds.length > 0)) {
        const campaignReportsRequestInfo = getCampaignsReportRequestInfo({timeFrame: timeFrame, adPlatform: adPlatform.platform, isDateRangeChange: isDateRangeChange, adAccountId: this.getAdAccountId(adPlatform), isTeamsFilter: isTeamsFilter, campaignIds: campaignIds, orgId: this.orgId})
        const reqPath = (campaignReportsRequestInfo && campaignReportsRequestInfo.path) ? campaignReportsRequestInfo.path : []
        const reqJsonBody = (campaignReportsRequestInfo && campaignReportsRequestInfo.jsonBody) ? campaignReportsRequestInfo.jsonBody : {}
        ApiHelper.callAwait({
          ms:  this.ms, method: 'POST', paths: reqPath,
          queryParams: { orgId: this.orgId},
          jsonBody: reqJsonBody
        }).then(results => {
          if(results && results.status === 'NOT_CONNECTED') {
            this.setState({
              campaignReports: [],
              dateWiseCampaignReports: [],
              timeFrame: timeFrame,
              adPlatformSelected: adPlatform,
              adPlatform: adPlatform,
              teams: teams,
              teamSelected: team,
              team: team,
              customError: {type: results.status, errMsg: results.message},
              fetchState: ApiHelper.State.READY,
              loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
            })
          } else if(results && results[1] && results[1].metadata && results[1].metadata.nextPageToken && adPlatform.platform === 'linkedin') {
            this.setState({
              campaignReports: [],
              dateWiseCampaignReports: [],
              timeFrame: timeFrame,
              adPlatformSelected: adPlatform,
              adPlatform: adPlatform,
              teams: teams,
              teamSelected: team,
              team: team,
              customError: {type: 'ERROR', errMsg: Helper.getString('unableToGenerateAdReport')},
              fetchState: ApiHelper.State.READY,
              loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
            })
          } else {
            const reports = this.getCampaignReports(results,adPlatform.platform)
            const newState = {
              campaignReports: reports.campaignReports,
              dateWiseCampaignReports: reports.dateWiseCampaignReports,
              timeFrame: timeFrame,
              adPlatformSelected: adPlatform,
              adPlatform: adPlatform,
              teams: teams,
              teamSelected: team,
              team: team,
              customError: null,
              fetchState: ApiHelper.State.READY,
              loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
            }
            if (!isDateRangeChange) {
              newState.customerData = reports.customerData
            }
            this.setState(newState)
          }
        }).catch(err => {
          this.setState({
            campaignReports: [],
            dateWiseCampaignReports: [],
            timeFrame: timeFrame,
            adPlatformSelected: adPlatform,
            adPlatform: adPlatform,
            teams: teams,
            teamSelected: team,
            team: team,
            customError: null,
            fetchState: ApiHelper.State.READY,
            loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
          })
        })
      } else {
        this.setState({
          campaignReports: [],
          dateWiseCampaignReports: [],
          timeFrame: timeFrame,
          adPlatformSelected: adPlatform,
          adPlatform: adPlatform,
          teams: teams,
          teamSelected: team,
          team: team,
          customError: null,
          fetchState: ApiHelper.State.READY,
          loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
        })
      }
    } else {
      this.setState({
        campaignReports: [],
        dateWiseCampaignReports: [],
        customError: null,
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
      })
    }

  }

  getAvailableDateRanges() {
    let availableDateRanges = []

    if(this.state.adPlatform && this.state.adPlatform.platform && ['meta', 'google', 'linkedin'].includes(this.state.adPlatform.platform)) {
      availableDateRanges = ['today', 'yesterday', 'this_week', 'this_month', 'last_7d', 'last_30d', 'last_90d', 'custom']
    }
    return availableDateRanges
  }

  renderMenuMobile() {
    const accountCurrency = this.getAccountCurrency()
    const accountTimezone = this.getAccountTimezone()
    if(this.state.teams && this.state.teams.length > 0) {
      return(
        <div className={css(Styles.menuContainer)}>
          <div className={css(Styles.menuActionsContainer)}>
            <div className={css(Styles.menuActionsRow)}>
              {this.adPlatforms && this.adPlatforms.length > 0 && <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
                <Autocomplete
                  value={this.state.adPlatformSelected || this.adPlatform}
                  options={this.adPlatforms}
                  onChange={(e, val) => this.onAdPlatformAutoCompleteChange(val)}
                  getOptionLabel={(option) => option.label || option.text}
                  getOptionSelected={(option, value) => option.key === value.key}
                  disableClearable
                  forcePopupIcon={this.adPlatforms.length > 1}
                  popupIcon={this.adPlatforms.length > 1 ? undefined : null}
                  open={this.adPlatforms.length > 1 ? undefined : false}
                  renderInput={params =>
                    <TextField
                      {...params}
                      variant={'standard'}
                      className={css(Styles.formControlFilters)}
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        readOnly: true,
                        classes: {
                          root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                          input: css(Styles.formInputStyle, Styles.textInput),
                        },
                      }} />}
                />
              </FormControl>}
              <div className={css(Styles.accountDetailsContainer, Styles.accountDetailsContainerMobile)}>
                {accountCurrency && ( <span className={css(Styles.reportMenuLabel)}> {'Currency : '}
                  <span className={css(Styles.reportMenuValue)}>{accountCurrency}</span>
                </span>)}
                {accountTimezone && ( <span className={css(Styles.reportMenuLabel)}> {'Time zone : '}
                  <span className={css(Styles.reportMenuValue)}>{accountTimezone}</span>
                </span>)}
              </div>
            </div>
            <div className={css(Styles.menuActionsRow)}>
              {this.state.teams && this.state.teams.length > 0 && <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
                <Autocomplete
                  value={this.state.teamSelected || this.team}
                  options={this.state.teams || this.teams}
                  onChange={(e, val) => this.onTeamsAutoCompleteChange(val)}
                  getOptionLabel={(option) => option.label || option.text}
                  getOptionSelected={(option, value) => option.key === value.key}
                  disableClearable
                  forcePopupIcon={this.state.teams.length > 1}
                  popupIcon={this.state.teams.length > 1 ? undefined : null}
                  open={this.state.teams.length > 1 ? undefined : false}
                  renderInput={params =>
                    <TextField
                      {...params}
                      variant={'standard'}
                      className={css(Styles.formControlFilters)}
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        readOnly: true,
                        classes: {
                          root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                          input: css(Styles.formInputStyle, Styles.textInput),
                        },
                      }} />}
                />
              </FormControl>}
              {<FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
                <ReactDateRangeWrapper
                  disabled={!this.state.adPlatformSelected}
                  onDateRangeChange={this.onDateRangeChange.bind(this)}
                  initialRange={this.dateRangeOptions}
                  availableDateRanges = {this.getAvailableDateRanges()}
                  timezone={Helper.getLocalTimezone()}
                  displayFieldStyle={Styles.displayFieldStyle}
                />
              </FormControl>}
              {!(this.state.fetchState === ApiHelper.State.LOADING && this.state.loadingMode === ApiHelper.LOADING_MODE.INSTANT_LOAD)  && <Tooltip title={'Refresh'} classes={{ popper: css(Styles.tooltip) }} arrow>
                <IconButton onClick={() => this.handleRefreshButtonClick()}>
                  <i className='material-icons-outlined' style={{ fontSize: 24, color: AppTheme.primaryColor }}>refresh</i>
                </IconButton>
              </Tooltip>}
              {(this.state.fetchState === ApiHelper.State.LOADING && this.state.loadingMode === ApiHelper.LOADING_MODE.INSTANT_LOAD) && UiHelper.itemLoadingViewButton(24)}
            </div>
          </div>
        </div>
      )
    }

    return(
      <div className={css(Styles.menuContainer)}>
        <div className={css(Styles.menuActionsContainer)}>
          <div className={css(Styles.menuActionsRow)}>
            <div className={css(Styles.accountDetailsContainer)}>
              {accountCurrency && ( <span className={css(Styles.reportMenuLabel)}> {'Currency : '}
                <span className={css(Styles.reportMenuValue)}>{accountCurrency}</span>
              </span>)}
              {accountTimezone && ( <span className={css(Styles.reportMenuLabel)}> {'Time zone : '}
                <span className={css(Styles.reportMenuValue)}>{accountTimezone}</span>
              </span>)}
            </div>
          </div>
          <div className={css(Styles.menuActionsRow)}>
            {this.adPlatforms && this.adPlatforms.length > 0 && <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
              <Autocomplete
                value={this.state.adPlatformSelected || this.adPlatform}
                options={this.adPlatforms}
                onChange={(e, val) => this.onAdPlatformAutoCompleteChange(val)}
                getOptionLabel={(option) => option.label || option.text}
                getOptionSelected={(option, value) => option.key === value.key}
                disableClearable
                forcePopupIcon={this.adPlatforms.length > 1}
                popupIcon={this.adPlatforms.length > 1 ? undefined : null}
                open={this.adPlatforms.length > 1 ? undefined : false}
                renderInput={params =>
                  <TextField
                    {...params}
                    variant={'standard'}
                    className={css(Styles.formControlFilters)}
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                      readOnly: true,
                      classes: {
                        root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                        input: css(Styles.formInputStyle, Styles.textInput),
                      },
                    }} />}
              />
            </FormControl>}
            {<FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
              <ReactDateRangeWrapper
                disabled={!this.state.adPlatformSelected}
                onDateRangeChange={this.onDateRangeChange.bind(this)}
                initialRange={this.dateRangeOptions}
                availableDateRanges = {this.getAvailableDateRanges()}
                timezone={Helper.getLocalTimezone()}
                displayFieldStyle={Styles.displayFieldStyle}
              />
            </FormControl>}
            {!(this.state.fetchState === ApiHelper.State.LOADING && this.state.loadingMode === ApiHelper.LOADING_MODE.INSTANT_LOAD)  && <Tooltip title={'Refresh'} classes={{ popper: css(Styles.tooltip) }} arrow>
              <IconButton onClick={() => this.handleRefreshButtonClick()}>
                <i className='material-icons-outlined' style={{ fontSize: 24, color: AppTheme.primaryColor }}>refresh</i>
              </IconButton>
            </Tooltip>}
            {(this.state.fetchState === ApiHelper.State.LOADING && this.state.loadingMode === ApiHelper.LOADING_MODE.INSTANT_LOAD) && UiHelper.itemLoadingViewButton(24)}
          </div>
        </div>
      </div>
    )
  }

  renderMenu() {
    const accountCurrency = this.getAccountCurrency()
    const accountTimezone = this.getAccountTimezone()
    return(
      <div className={css(Styles.menuContainer)}>
        <div className={css(Styles.menuActionsContainer)}>
          {this.adPlatforms && this.adPlatforms.length > 0 && <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
            <Autocomplete
              value={this.state.adPlatformSelected || this.adPlatform}
              options={this.adPlatforms}
              onChange={(e, val) => this.onAdPlatformAutoCompleteChange(val)}
              getOptionLabel={(option) => option.label || option.text}
              getOptionSelected={(option, value) => option.key === value.key}
              disableClearable
              forcePopupIcon={this.adPlatforms.length > 1}
              popupIcon={this.adPlatforms.length > 1 ? undefined : null}
              open={this.adPlatforms.length > 1 ? undefined : false}
              renderInput={params =>
                <TextField
                  {...params}
                  variant={'standard'}
                  className={css(Styles.formControlFilters)}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    readOnly: true,
                    classes: {
                      root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                      input: css(Styles.formInputStyle, Styles.textInput),
                    },
                  }} />}
            />
          </FormControl>}
          {this.state.teams && this.state.teams.length > 0 && <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
            <Autocomplete
              value={this.state.teamSelected || this.team}
              options={this.state.teams || this.teams}
              onChange={(e, val) => this.onTeamsAutoCompleteChange(val)}
              getOptionLabel={(option) => option.label || option.text}
              getOptionSelected={(option, value) => option.key === value.key}
              disableClearable
              forcePopupIcon={this.state.teams.length > 1}
              popupIcon={this.state.teams.length > 1 ? undefined : null}
              open={this.state.teams.length > 1 ? undefined : false}
              renderInput={params =>
                <TextField
                  {...params}
                  variant={'standard'}
                  className={css(Styles.formControlFilters)}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    readOnly: true,
                    classes: {
                      root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                      input: css(Styles.formInputStyle, Styles.textInput),
                    },
                  }} />}
            />
          </FormControl>}
          {<FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
            <ReactDateRangeWrapper
              disabled={!this.state.adPlatformSelected}
              onDateRangeChange={this.onDateRangeChange.bind(this)}
              initialRange={this.dateRangeOptions}
              availableDateRanges = {this.getAvailableDateRanges()}
              timezone={Helper.getLocalTimezone()}
              displayFieldStyle={Styles.displayFieldStyle}
            />
          </FormControl>}
          {!(this.state.fetchState === ApiHelper.State.LOADING && this.state.loadingMode === ApiHelper.LOADING_MODE.INSTANT_LOAD)  && <Tooltip title={'Refresh'} classes={{ popper: css(Styles.tooltip) }} arrow>
            <IconButton onClick={() => this.handleRefreshButtonClick()}>
              <i className='material-icons-outlined' style={{ fontSize: 24, color: AppTheme.primaryColor }}>refresh</i>
            </IconButton>
          </Tooltip>}
          {(this.state.fetchState === ApiHelper.State.LOADING && this.state.loadingMode === ApiHelper.LOADING_MODE.INSTANT_LOAD) && UiHelper.itemLoadingViewButton(24)}
        </div>
        <div className={css(Styles.accountDetailsContainer)}>
          {accountCurrency && ( <span className={css(Styles.reportMenuLabel)}> <span>Currency</span>
            <span className={css(Styles.reportMenuValue)}>{accountCurrency}</span>
          </span>)}
          {accountTimezone && ( <span className={css(Styles.reportMenuLabel)}> <span>Time zone</span>
            <span className={css(Styles.reportMenuValue)}>{accountTimezone}</span>
          </span>)}
        </div>
      </div>
    )
  }

  renderReportsMenubar() {
    if(this.state.timeFrame) {
      if(this.state.timeFrame === 'custom' || (this.state.adPlatform && this.state.adPlatform.platform === 'google' && this.state.timeFrame === 'last_90d')) {
        this.dateRangeOptions = {
          id: this.state.timeFrame.id,
          startDate: this.state.timeFrame.startValue,
          endDate: this.state.timeFrame.endValue
        }
      } else {
        this.dateRangeOptions = {
          id: this.state.timeFrame.id
        }
      }
    } else {
      const defaultTimeframe = getTimeFrameData({id: this.timeFrame})
      this.dateRangeOptions = {
        id: defaultTimeframe.id,
      }
    }
    return(<div className={css(Styles.reportsContainer)}>
      {!this.isMobileView && this.renderMenu()}
      {this.isMobileView && this.renderMenuMobile()}
    </div>)
  }

  renderAggregatedStats() {
    if(this.state.adPlatform && this.state.adPlatform.platform) {
      const platform = this.state.adPlatform.platform
      const aggregatedStats = getAggregatedStats(this.state.dateWiseCampaignReports, platform)
      let cardsData = []
      if(aggregatedStats) {
        cardsData = getCardsData(aggregatedStats, platform, this.isMobileView)

        if(cardsData && cardsData.length > 0) {
          return(<div className={css(Styles.tableStatItem)}>
            {cardsData.map((row)=>(<Grid container className={css(Styles.numericStatContainer)}>
              {row.map((card)=>(
                <StatCard
                  xs={6}
                  sm={6}
                  key={card.key}
                  text={card.text}
                  subText={card.subText}
                  cardIndex={card.cardIndex}
                  padding={card.padding}
                  cardId={card.cardId}
                />))}
            </Grid>))}
          </div>)
        }
      }
    }
    return null
  }

  handleConnectLinkedInButtonClick() {
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
    })

    const reqPath = ['miscs', 'get-linkedin-ads-oauth-url']
    ApiHelper.callAwait({
      ms:  this.ms, method: 'GET', paths: reqPath,
      queryParams: { orgId: this.orgId, postAuthRedirectUrl: window.location.href},
    }).then(results => {
      const url = results.url
      this.setState({
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
      })
      window.open(url, '_self')
    }).catch(err => {
      this.setState({
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
        customError: {type: 'NOT_CONNECTED', errMsg: Helper.getString('unableToConnectLinkedInAdAccount')},
      })
    })
  }

  renderBelowTable() {
    if(!this.state.adPlatformSelected || this.state.customError || !this.state.campaignReports || this.state.campaignReports.length === 0) {
      let errorDetails = {}

      if(!this.adPlatforms || this.adPlatforms.length === 0) {
        errorDetails = {
          image: require('../../../assets/images/empty.svg'),
          message: Helper.getString('adsAccountConfigurationNotFound')
        }
      } else if(!this.state.adPlatformSelected) {
        errorDetails = {
          image: require('../../../assets/images/empty.svg'),
          message: Helper.getString('adsAccountNotConfigured')
        }
      } else if(this.state.customError && this.state.customError.errMsg) {
        errorDetails = {
          message: this.state.customError.errMsg
        }
        if(this.state.customError.type === 'NOT_CONNECTED') {
          errorDetails = {
            ...errorDetails,
            buttonIcon: <LinkedInIcon style={{fontSize: 28}}/>,
            buttonText: 'Connect LinkedIn',
            action: this.handleConnectLinkedInButtonClick.bind(this),
          }
        }
      } else if(!this.state.campaignReports) {
        errorDetails = {
          image: require('../../../assets/images/empty.svg'),
          message: Helper.getString('adsReportNotAvailable'),
          buttonText: 'Refresh',
          action: this.handleRefreshButtonClick.bind(this),
        }
      } else if(this.state.campaignReports && this.state.campaignReports.length === 0) {
        errorDetails = {
          image: require('../../../assets/images/no-data.svg'),
          message: Helper.getString('adsReportIsEmpty')
        }
      }

      return(
        <div className={css(Styles.outerContainer)}>
          <div className={css(Styles.reportDashboardContainer)}>
            {this.renderReportsMenubar()}
            <div className={css(Styles.reportsContainer, Styles.reportsDataContainer)}>
              {UiHelper.customErrorViewWithRefresh(errorDetails)}
            </div>
          </div>
        </div>
      )
    }

    const reportTitle = 'Campaigns'
    const report = this.state.campaignReports && this.state.adPlatform && generateCampaignsReport(this.state.campaignReports,this.state.adPlatform.platform)
    const dateWiseReport = this.state.dateWiseCampaignReports && this.state.adPlatform && generateDateWiseCampaignsReport(this.state.dateWiseCampaignReports, this.state.adPlatform.platform)
    const isTeamsEnabled = this.state.teams && this.state.teams.length > 0

    return(
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.reportDashboardContainer)}>
          {this.renderReportsMenubar()}
          <div className={css(Styles.reportsContainer, Styles.reportsDataContainer, isTeamsEnabled && Styles.reportsDataContainerWithTeams)}>
            {this.renderAggregatedStats()}
            <div className={css(Styles.tableStatItem)}>
              <TableCard item={{data: report || {}, title: reportTitle, maxRows: 100}} tableRowActions={this.allCampaignsTableActions.bind(this)}/>
            </div>
            <div className={css(Styles.tableStatItem)}>
              <TableCard item={{data: dateWiseReport || {}, title: 'Date-wise', maxRows: 100}}/>
            </div>
          </div>
        </div>
        {this.state.adsModalOpen ? this.renderAdsModal() : ''}
      </div>
    )
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formData.isAnalyze) {
      return this.customSubmitForAnalyze(options)
    }

    if (formData.isGeneratedAdReport) {
      return this.customSubmitForGeneratedAdReport(options)
    }
    if (formData._isJob) {
      try {
        await ApiHelper.callAwait({
          method: this.state.apiMethod,
          endPoint: this.state.apiEndPoint,
          jsonBody: formData,
        })
        window.open(this.baseRoute() + '/jobscrm', '_self')
        return
      } catch(err) {
        const errorMessage = Helper.getErrorMsg(err);
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }
    }

    return caller.submit.call(caller, formData, true);
  }
}

export const Styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',

  },
  reportDashboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    maxWidth: AppTheme.viewPort,
    overflow: 'hidden',
    marginBottom: 20,
    '@media (max-width: 1024px)': {
      gap: 0,
    }
  },
  reportsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 10,
  },
  reportsDataContainer: {
    marginTop: 51,
    justifyContent: 'center',
    '@media (max-width: 1024px)': {
      marginTop: 82,
      maxWidth: '96vw'
    }
  },
  reportsDataContainerWithTeams: {
    '@media (max-width: 1024px)': {
      marginTop: 120,
      maxWidth: '96vw'
    }
  },
  tableStatItem: {
    flex: 1,
    minWidth: '100%',
    height: '100%',
    maxWidth: window.innerWidth - AppTheme.drawerWidth - (AppTheme.adminPagePadding * 2),
    '@media (max-width: 767px)': {
      width: '100%',
      alignSelf: 'center',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  menuContainer: {
    position: 'fixed',
    top: 140,
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    boxSizing: 'border-box',
    maxWidth: AppTheme.viewPort,
    width: '100%',
    backgroundColor: AppTheme.secondaryBg,
    paddingBottom: 15,
    '@media (max-width: 767px)': {
      // paddingLeft: 16,
      gap: 0,
      justifyContent: 'space-around',
      maxWidth: '96vw',
      paddingBottom: 5,
    },
    '@media (max-width: 1024px)': {
      top: 50,
      paddingTop: 5,
      maxWidth: '96vw',
      justifyContent: 'flex-start',
    }
  },
  menuActionsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    '@media (max-width: 1024px)': {
      width: '100%',
      gap: 5,
      flexDirection: 'column'
    }
  },
  menuActionsRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 5
  },
  reportMenuLabel: {
    color: '#9B9B9B',
    fontSize: 16,
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    '@media (max-width: 1024px)': {
      fontSize: 10,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  },
  reportMenuValue: {
    color: CommonTheme.textColor,
    fontSize: 16,
    fontWeight: 'initial',
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  formControlMainFilters: {
    width: 240,
    '@media (min-width: 1024px) and (max-width: 1280px)': {
      width: 200,
      alignSelf: 'center',
    },
    '@media (min-width: 768px) and (max-width: 1024px)': {
      width: '60%',
      alignSelf: 'center',
    },
    '@media (max-width: 767px)': {
      width: '60%',
      alignSelf: 'center',
    },
  },
  formControlFilters: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden'
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  autoCompleteInputRoot: {
    paddingRight: 48,
    '@media (max-width: 440px)': {
      paddingRight: 18,
    },
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  textInput: {
    padding: '4px 0px',
    '@media (max-width: 440px)': {
      fontSize: 12,
    },
  },
  numericStatContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    marginBottom: 16,
    gap: '16px',
    '@media (max-width: 767px)': {
      marginBottom: 4,
      gap: '4px',
    },
  },
  tooltip: {
    zIndex: 9999999999
  },
  customRoot: {
    zIndex: 13000
  },
  customPaper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      borderRadius: 0,
      width: '95%',
      height: 'max-content',
      maxHeight: '95%'
    },
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  modalHeader: {
    // backgroundColor: 'whitesmoke',
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: 20,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
    }
  },
  modalTitle: {
    color: CommonTheme.textColor,
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // marginRight: 28,
    flex: 1,
    '@media (max-width: 767px)': {
      fontSize: 20,
      marginRight: 43,
    }
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 30,
    paddingRight: 30,
    minHeight: 400,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
      minHeight: 200,
    }
  },
  modalCloseButton: {
    // position: 'absolute',
    // top: 23,
    // right: 30,
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    border: 'none'
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    border: '1.5px solid' + AppTheme.primaryColor,
    fill: AppTheme.primaryColor,
    borderRadius: 8
  },
  cellBody: {
    backgroundColor: 'white',
    color: CommonTheme.textColor,
    // minHeight: 72,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    fontSize: 16,
    textAlign: 'center',
    padding: '16px 5px',
    verticalAlign: 'middle',
    wordBreak: 'break-all',
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  statusBadge: {
    backgroundColor: AppTheme.primaryBg,
    // color: 'white',
    padding: 2,
    borderRadius: 10,
    margin: 5,
    wordBreak: 'keep-all',
    display: 'block',
    textAlign: 'center'
  },
  statusBadgeActive: {
    backgroundColor: '#3BDE86',
    color: '#222222'
  },
  statusBadgeActiveSecondary: {
    backgroundColor: '#FFD7BB',
    color: '#222222'
  },
  adSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: 5,
    minWidth: 250,
    maxWidth: 300,
  },
  headline: {
    fontSize: 14,
    textAlign: 'left',
    fontWeight: 500,
    wordBreak: 'break-word',
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  finalUrl: {
    display: 'inline-block',
    fontSize: 12,
    textAlign: 'left',
    textDecoration: 'none',
    color: AppTheme.primaryColor,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
      textDecorationColor: AppTheme.primaryColor,
      textUnderlineOffset: 2,
    },
    '@media (max-width: 767px)': {
      fontSize: 8,
    },
  },
  descriptions: {
    fontSize: 12,
    textAlign: 'left',
    textColor: AppTheme.primaryBg,
    wordBreak: 'normal',
    paddingLeft: 10,
    margin: 0,
    '@media (max-width: 767px)': {
      fontSize: 8,
    },
  },
  accountDetailsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20
  },
  accountDetailsContainerMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 5,
  },
  displayFieldStyle: {
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  }
})
